/* ============================================================
   QCC Custom Theme — JavaScript
   ============================================================ */

(function() {
  'use strict';

  /* ============================================================
     SCROLL REVEAL ANIMATIONS
     ============================================================ */
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('vis');
      }
    });
  }, { threshold: 0.07 });

  document.querySelectorAll('.fu').forEach(function(el) {
    observer.observe(el);
  });

  /* ============================================================
     SHOP TABS (collection filtering)
     ============================================================ */
  document.addEventListener('click', function(e) {
    var tab = e.target.closest('.shop-tab');
    if (!tab) return;
    var tabs = tab.parentElement.querySelectorAll('.shop-tab');
    tabs.forEach(function(t) { t.classList.remove('on'); });
    tab.classList.add('on');

    var filter = (tab.getAttribute('data-filter') || tab.textContent.trim()).toLowerCase();
    var cards = document.querySelectorAll('.prod-grid .pc');
    cards.forEach(function(card) {
      if (filter === 'all') {
        card.style.display = '';
      } else {
        var tags = card.getAttribute('data-tags') || '';
        card.style.display = tags.toLowerCase().indexOf(filter) > -1 ? '' : 'none';
      }
    });
  });

  /* ============================================================
     SUBSCRIPTION FREQUENCY SELECTOR
     ============================================================ */
  document.addEventListener('click', function(e) {
    var opt = e.target.closest('.sub-opt');
    if (!opt) return;
    var opts = opt.parentElement.querySelectorAll('.sub-opt');
    opts.forEach(function(o) { o.classList.remove('on'); });
    opt.classList.add('on');
  });

  /* ============================================================
     MODALS
     ============================================================ */
  window.QCC = window.QCC || {};

  var localEventDestinations = {
    qcc_local_order_ahead_click: 'shared_ordering',
    qcc_local_directions_click: 'directions',
    qcc_local_call_click: 'telephone',
    qcc_local_catering_click: 'catering',
    qcc_local_ecommerce_click: 'ecommerce'
  };
  var localLocations = ['plainfield', 'clifton'];
  var localPlacements = ['hero', 'essentials', 'catering', 'final', 'navigation'];

  function validLocalPayload(eventName, payload) {
    if (!payload || Object.keys(payload).sort().join(',') !== 'destination_kind,location,page_handle,placement,schema_version') return false;
    return payload.schema_version === 1
      && localLocations.indexOf(payload.location) !== -1
      && payload.location === payload.page_handle
      && localPlacements.indexOf(payload.placement) !== -1
      && localEventDestinations[eventName] === payload.destination_kind;
  }

  QCC.publishLocalEvent = function(eventName, payload) {
    if (!validLocalPayload(eventName, payload)) return false;
    if (!window.Shopify || !Shopify.customerPrivacy || typeof Shopify.customerPrivacy.analyticsProcessingAllowed !== 'function') return false;
    if (Shopify.customerPrivacy.analyticsProcessingAllowed() !== true) return false;
    if (!Shopify.analytics || typeof Shopify.analytics.publish !== 'function') return false;
    Shopify.analytics.publish(eventName, payload);
    return true;
  };

  QCC.handleLocalAction = function(event) {
    var link = event.target && event.target.closest ? event.target.closest('a[data-qcc-local-event]') : null;
    if (!link) return;
    QCC.publishLocalEvent(link.getAttribute('data-qcc-local-event'), {
      schema_version: 1,
      location: link.getAttribute('data-qcc-local-location'),
      page_handle: link.getAttribute('data-qcc-local-page-handle'),
      placement: link.getAttribute('data-qcc-local-placement'),
      destination_kind: link.getAttribute('data-qcc-local-destination-kind')
    });
  };

  document.addEventListener('click', function(event) {
    QCC.handleLocalAction(event);
  });

  /* ============================================================
     RECHARGE WIDGET PRECEDENCE (F-043)

     Recharge's legacy Auto inject setting is global and currently
     published. On product forms that already contain QCC's provider-derived
     theme picker, neutralize only the separately injected Recharge control.
     Disabling its controls is essential: visually hidden form controls can
     otherwise still submit a second selling_plan value.

     TWO SURFACES, ONE RULE. The PDP form is not the only add-to-cart form
     Recharge injects into. The gift-sampler form inside #cartDrawer is also
     form[action*="/cart/add"], and it has NO purchase-mode choice of its own:
     the sampler is a one-time add. An injected subscribe radio and 7-day
     cadence selector there contradicts the drawer's own line text, which
     header.liquid derives from item.selling_plan_allocation. The order is
     not at risk -- the injected controls cannot serialize a competing
     selling_plan from outside the canonical form -- but the shopper is being
     told two different things at the moment of purchase.

     The scope stays narrow on purpose: the canonical theme picker, the
     drawer, and nothing else. A form with neither is somebody else's
     surface and is left exactly as found.
     ============================================================ */
  QCC.suppressInjectedRechargeWidgets = function(root) {
    root = root || document;
    var suppressed = 0;
    var forms = root.querySelectorAll('form[action*="/cart/add"]');

    forms.forEach(function(form) {
      var canonical = form.querySelector('[data-pdp-sub-picker-owner="theme"]');
      // `closest` covers any add-to-cart form the drawer may come to hold;
      // the explicit gift attribute covers the one it holds today even if a
      // caller hands us a detached subtree with no drawer ancestor.
      var drawerSurface =
        (typeof form.hasAttribute === 'function' && form.hasAttribute('data-qcc-gift-form')) ||
        (typeof form.closest === 'function' && !!form.closest('#cartDrawer'));
      if (!canonical && !drawerSurface) return;

      var widgetRoots = form.querySelectorAll(
        '.rc-widget-injection-parent, .rc_container_wrapper, .rc-container-wrapper, [data-recharge-widget]'
      );

      widgetRoots.forEach(function(widget) {
        widget.hidden = true;
        widget.setAttribute('aria-hidden', 'true');
        widget.setAttribute('data-qcc-recharge-suppressed', 'true');
        widget.querySelectorAll('input, select, textarea, button').forEach(function(control) {
          control.disabled = true;
        });
        suppressed += 1;
      });

      // Only the canonical form has a theme selling plan to reconcile. The
      // drawer surfaces have none, and calling this for them would look for
      // state that does not exist.
      if (canonical) QCC.syncThemeSellingPlan(form);

    });

    return suppressed;
  };

  QCC.syncThemeSellingPlan = function(form) {
    var nativeInput = form.querySelector('[data-pdp-sub-input]');
    var nativeFrequency = form.querySelector('[data-pdp-sub-freq]');
    var selectedMode = form.querySelector('input[name="pdp_purchase_mode"]:checked');
    if (!nativeInput || !selectedMode) return;

    if (selectedMode.value === 'subscription' && nativeFrequency && nativeFrequency.value) {
      nativeInput.value = nativeFrequency.value;
    } else if (selectedMode.value === 'onetime') {
      nativeInput.value = '';
    }
  };

  QCC.suppressInjectedRechargeWidgets(document);
  if (typeof MutationObserver !== 'undefined' && document.body) {
    new MutationObserver(function() {
      QCC.suppressInjectedRechargeWidgets(document);
    }).observe(document.body, { childList: true, subtree: true });
  }

  QCC.experimentEnabled = function(name) {
    var experiments = window.QCC_experiments || {};
    return experiments[name] === true;
  };

  var packagingExposures = {};
  var lastShippingThresholdState = null;
  var shippingUnlockPublished = false;

  QCC.publishPackagingEvent = function(name, payload) {
    var shopifyAnalytics = window.Shopify && window.Shopify.analytics;
    if (!shopifyAnalytics || typeof shopifyAnalytics.publish !== 'function') return false;
    try {
      shopifyAnalytics.publish(name, payload);
      return true;
    } catch (e) {
      return false;
    }
  };

  QCC.publishConversionEvent = function(name, payload) {
    var shopifyAnalytics = window.Shopify && window.Shopify.analytics;
    if (!shopifyAnalytics || typeof shopifyAnalytics.publish !== 'function') return false;
    try {
      shopifyAnalytics.publish(name, payload);
      return true;
    } catch (e) {
      return false;
    }
  };

  var conversionMediaQuery = typeof window.matchMedia === 'function'
    ? window.matchMedia('(max-width: 749px)')
    : null;

  function conversionEligible() {
    return QCC.experimentEnabled('mobileCollectionPath') &&
      conversionMediaQuery &&
      conversionMediaQuery.matches;
  }

  function conversionPayload(surface, action) {
    return {
      experiment: 'mobile_collection_path',
      variant: 'treatment',
      surface: surface,
      action: action
    };
  }

  function conversionElementVisible(element) {
    var node = element;
    while (node) {
      if (node.hidden === true) return false;
      if (node.nodeType === 1 && typeof window.getComputedStyle === 'function') {
        var style = window.getComputedStyle(node);
        if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || style.opacity === '0') {
          return false;
        }
      }
      node = node.parentNode;
    }
    return true;
  }

  var conversionExposures = {};
  var conversionObserver = null;
  var conversionObserverGeneration = 0;
  QCC.trackConversionExposures = function() {
    conversionObserverGeneration += 1;
    var observerGeneration = conversionObserverGeneration;
    if (conversionObserver) {
      conversionObserver.disconnect();
      conversionObserver = null;
    }
    if (!conversionEligible() || typeof IntersectionObserver === 'undefined') return;
    conversionObserver = new IntersectionObserver(function(entries) {
      if (observerGeneration !== conversionObserverGeneration || !conversionEligible()) return;
      entries.forEach(function(entry) {
        if (!entry.isIntersecting || entry.intersectionRatio <= 0 || !conversionElementVisible(entry.target)) return;
        var surface = entry.target.getAttribute('data-qcc-conversion-surface');
        if ((surface !== 'home' && surface !== 'collection') || conversionExposures[surface]) return;
        if (QCC.publishConversionEvent(
          'qcc_conversion_exposure',
          conversionPayload(surface, 'treatment_viewed')
        )) conversionExposures[surface] = true;
      });
    }, { threshold: 0.01 });

    document.querySelectorAll('[data-qcc-conversion-surface]').forEach(function(element) {
      conversionObserver.observe(element);
    });
  };

  document.addEventListener('click', function(e) {
    if (!conversionEligible()) return;
    var target = e.target.closest('[data-qcc-conversion-action]');
    if (!target) return;
    var surface = target.getAttribute('data-qcc-conversion-surface');
    if (!surface && typeof target.closest === 'function') {
      var surfaceElement = target.closest('[data-qcc-conversion-surface]');
      surface = surfaceElement && surfaceElement.getAttribute('data-qcc-conversion-surface');
    }
    var action = target.getAttribute('data-qcc-conversion-action');
    var approved = (surface === 'home' && action === 'primary_cta_clicked') ||
      (surface === 'collection' && action === 'product_clicked');
    if (!approved) return;
    QCC.publishConversionEvent('qcc_conversion_interaction', conversionPayload(surface, action));
  });

  function packagingPayload(experimentKey, surface, action, thresholdState) {
    return {
      schema_version: '1',
      experiment_key: experimentKey,
      rollout_state: 'enabled',
      surface: surface,
      action: action,
      threshold_state: thresholdState
    };
  }

  function packagingSurface(element) {
    return element && element.closest && element.closest('.cart-page') ? 'cart_page' : 'cart_drawer';
  }

  function packagingElementVisible(element) {
    if (!element || element.hidden === true) return false;
    var node = element.parentNode;
    while (node) {
      if (node.hidden === true || (node.style && node.style.display === 'none')) return false;
      node = node.parentNode;
    }
    var drawer = element.closest && element.closest('#cartDrawer');
    return !drawer || Boolean(drawer.classList && drawer.classList.contains('open'));
  }

  function publishPackagingExposure(experimentKey, surface, action, thresholdState) {
    if (packagingExposures[experimentKey]) return;
    if (QCC.publishPackagingEvent(
      'qcc_packaging_exposure',
      packagingPayload(experimentKey, surface, action, thresholdState)
    )) packagingExposures[experimentKey] = true;
  }

  function trackMultiBagExposure(scope) {
    if (!QCC.experimentEnabled('multiBag')) return;
    var multiBagOffer = scope.querySelector('[data-qcc-multi-bag-offer]');
    var multiBagButton = multiBagOffer && typeof multiBagOffer.querySelector === 'function'
      ? multiBagOffer.querySelector('[data-qcc-multi-bag]')
      : scope.querySelector('[data-qcc-multi-bag]');
    if (packagingElementVisible(multiBagOffer) && multiBagButton && !multiBagButton.disabled) {
      publishPackagingExposure('multi_bag', 'product_page', 'offer_viewed', 'not_applicable');
    }
  }

  QCC.trackPackagingExposures = function(scope, merchandiseTotalCents) {
    scope = scope || document;

    trackMultiBagExposure(scope);

    if (QCC.experimentEnabled('shippingProgress')) {
      var progressElements = scope.querySelectorAll('[data-qcc-shipping-progress]');
      var visibleProgress = Array.prototype.find.call(progressElements, function(progress) {
        return packagingElementVisible(progress);
      });
      if (visibleProgress) {
        var total = merchandiseTotalCents;
        var meter = visibleProgress.querySelector && visibleProgress.querySelector('[data-qcc-shipping-meter]');
        if (typeof total !== 'number' && meter) total = Number(meter.value);
        if (
          packagingSurface(visibleProgress) === 'cart_drawer' &&
          typeof total === 'number' &&
          !isNaN(total)
        ) {
          lastShippingThresholdState = total >= 4500 ? 'unlocked' : 'below';
        }
        publishPackagingExposure(
          'shipping_progress',
          packagingSurface(visibleProgress),
          'progress_viewed',
          total >= 4500 ? 'unlocked' : 'below'
        );
      }
    }

    if (QCC.experimentEnabled('giftSampler')) {
      var giftOffers = scope.querySelectorAll('[data-qcc-gift-offer]');
      var visibleGift = Array.prototype.find.call(giftOffers, function(offer) {
        return packagingElementVisible(offer);
      });
      if (visibleGift) {
        publishPackagingExposure(
          'gift_sampler',
          packagingSurface(visibleGift),
          'offer_viewed',
          'not_applicable'
        );
      }
    }
  };

  QCC.openModal = function(id) {
    var modal = document.getElementById(id);
    if (modal) modal.classList.add('open');
  };

  QCC.closeModal = function(id) {
    var modal = document.getElementById(id);
    if (modal) modal.classList.remove('open');
  };

  // Close on backdrop click
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('modal-ov')) {
      e.target.classList.remove('open');
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.modal-ov.open').forEach(function(m) {
        m.classList.remove('open');
      });
    }
  });

  // Wire up modal triggers
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-modal-open]');
    if (trigger) {
      e.preventDefault();
      QCC.openModal(trigger.getAttribute('data-modal-open'));
    }
    var closer = e.target.closest('[data-modal-close]');
    if (closer) {
      e.preventDefault();
      QCC.closeModal(closer.getAttribute('data-modal-close'));
    }
    var close = e.target.closest('.m-close');
    if (close) {
      var modal = close.closest('.modal-ov');
      if (modal) modal.classList.remove('open');
    }
  });

  /* ============================================================
     LOYALTY MODAL
     ============================================================ */
  QCC.openLoyaltyModal = function(location) {
    // Reset to form view
    var formEl = document.getElementById('loyaltyForm');
    var successEl = document.getElementById('loyaltySuccess');
    var alreadyEl = document.getElementById('loyaltyAlready');
    var errorEl = document.getElementById('loyaltyError');
    var submitBtn = formEl ? formEl.querySelector('.m-submit') : null;
    if (formEl) formEl.style.display = 'block';
    if (successEl) successEl.style.display = 'none';
    if (alreadyEl) alreadyEl.style.display = 'none';
    if (errorEl) errorEl.style.display = 'none';
    if (submitBtn) { submitBtn.textContent = 'Get My Promo Code \u2192'; submitBtn.disabled = false; }
    var tag = document.getElementById('loyaltyTag');
    if (tag) tag.textContent = location + ' — Square Loyalty Program';
    QCC.openModal('loyaltyModal');
  };

  // ---- Configure your backend URL here ----
  var CAFE_PROMO_API = 'https://worker-production-c2c8.up.railway.app/api/leads';

  QCC.claimCafeOffer = function() {
    var name = document.getElementById('loyaltyName');
    var email = document.getElementById('loyaltyEmail');
    var phone = document.getElementById('loyaltyPhone');
    var error = document.getElementById('loyaltyError');
    var submitBtn = document.querySelector('#loyaltyForm .m-submit');
    // Honeypot — hidden from real users via off-screen CSS. If this is filled, it's a bot.
    var honeypot = document.getElementById('loyaltyWebsite');

    // Validate
    if (!name.value.trim() || !email.value.trim() || !phone.value.trim()) {
      if (error) { error.textContent = 'Please fill out all fields.'; error.style.display = 'block'; }
      return;
    }
    if (email.value.indexOf('@') === -1) {
      if (error) { error.textContent = 'Please enter a valid email address.'; error.style.display = 'block'; }
      return;
    }
    if (!CAFE_PROMO_API) {
      if (error) { error.textContent = 'Promo service not configured yet.'; error.style.display = 'block'; }
      return;
    }

    // Turnstile token (only present if the widget is rendered)
    var turnstileToken = '';
    try {
      var tsResp = document.querySelector('#loyaltyForm [name="cf-turnstile-response"]');
      if (tsResp && tsResp.value) turnstileToken = tsResp.value;
    } catch (e) { /* no-op */ }

    // Disable button while processing
    if (submitBtn) { submitBtn.textContent = 'Processing...'; submitBtn.disabled = true; }
    if (error) error.style.display = 'none';

    fetch(CAFE_PROMO_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: name.value.trim(),
        email: email.value.trim(),
        phone: phone.value.trim(),
        source: 'cafe_promo',
        website: honeypot ? honeypot.value : '',  // honeypot trip value
        cf_turnstile_token: turnstileToken
      })
    })
    .then(function(r) { return r.json().then(function(data) { return { status: r.status, data: data }; }); })
    .then(function(result) {
      if (result.data.error === 'already_claimed') {
        // Show already-claimed view
        document.getElementById('loyaltyForm').style.display = 'none';
        document.getElementById('loyaltyAlready').style.display = 'block';
        return;
      }
      if (result.data.error === 'rate_limited') {
        if (error) { error.textContent = 'Too many submissions from your network. Try again in an hour.'; error.style.display = 'block'; }
        if (submitBtn) { submitBtn.textContent = 'Get My Promo Code \u2192'; submitBtn.disabled = false; }
        return;
      }
      if (result.data.error === 'verification_failed') {
        if (error) { error.textContent = 'Could not verify you\'re human. Please refresh the page and try again.'; error.style.display = 'block'; }
        if (submitBtn) { submitBtn.textContent = 'Get My Promo Code \u2192'; submitBtn.disabled = false; }
        return;
      }
      if (!result.data.success) {
        if (error) { error.textContent = result.data.error || 'Something went wrong.'; error.style.display = 'block'; }
        if (submitBtn) { submitBtn.textContent = 'Get My Promo Code \u2192'; submitBtn.disabled = false; }
        return;
      }
      // Success — show confirmation
      document.getElementById('loyaltyForm').style.display = 'none';
      document.getElementById('loyaltySuccess').style.display = 'block';
    })
    .catch(function() {
      if (error) { error.textContent = 'Network error. Please try again.'; error.style.display = 'block'; }
      if (submitBtn) { submitBtn.textContent = 'Get My Promo Code \u2192'; submitBtn.disabled = false; }
    });
  };

  /* ============================================================
     CHAT WIDGET
     ============================================================ */
  QCC.toggleChat = function() {
    var panel = document.getElementById('chatPanel');
    var badge = document.getElementById('chatBadge');
    if (panel) panel.classList.toggle('open');
    if (badge) badge.style.display = 'none';
  };

  /* ============================================================
     SHELL DIALOG CONTROLLER (F-125)

     The mobile navigation panel and the cart drawer are the two
     full-height overlays in the storefront shell. Before this
     controller they only toggled a class: twelve controls stayed
     focusable while closed, opening moved no focus, Tab leaked from
     one panel into the other, Escape did nothing, and closing
     restored nothing.

     One dialog is open at a time. That single rule fixes the Tab
     leak and the scroll-lock double-restore.

     ESCAPE PRECEDENCE. .modal-ov is z-index 500; this drawer is 351
     and the nav panel 301. A legacy modal opened over an overlay
     paints on top and owns the keyboard, so whenever any .modal-ov
     is open this controller stands down completely — no Escape, no
     Tab trap — and the handler above closes the modal.

     INERT BOUNDARY. A fixed selector list cannot express it. The
     chat panel renders after </footer> inside the footer section;
     the skip link is a direct body child; Talkable and the Zipify
     footer inject more body-level nodes at runtime; and
     {% section 'header' %} wraps .topbar, .qcc-nav, #cartStatus AND
     both panels in one #shopify-section-header div. So we walk from
     the open panel to <body>, marking the ancestor chain, and inert
     every sibling along the way.

     #cartStatus is exempt: it is the polite live region
     announceCartStatus() writes into, and inerting it would silence
     every cart announcement made while the drawer is open. For the
     same reason neither panel carries aria-modal.

     We mark our own attributes with data-qcc-inert so releasing
     never clears inert that something else set.
     ============================================================ */
  var SHELL_DIALOGS = {
    mobileNav: {
      panelId: 'mobileNavPanel',
      overlayId: 'mobileNavOverlay',
      overlayDisplay: true,        // shown via style.display
      triggerSelector: '.mobile-nav-toggle',
      initialFocusSelector: '.mobile-nav-close'
    },
    cartDrawer: {
      panelId: 'cartDrawer',
      overlayId: 'cartDrawerOverlay',
      overlayDisplay: false,       // shown via the .open class
      triggerSelector: '.nav-cart',
      initialFocusSelector: '.cart-drawer-title'
    }
  };

  // iframe and [contenteditable] matter in practice: upsell and cart apps
  // routinely inject an iframe into #cartDrawerItems, and omitting it would
  // make the trap compute `last` wrongly and let Tab leave the dialog.
  // `[contenteditable]` alone is wrong: contenteditable="false" is the explicit
  // opt-OUT and is never focusable. Matching it makes it the trap boundary, so
  // a wrap lands on a control the browser refuses and focus is lost.
  var SHELL_FOCUSABLE = 'a[href],area[href],button,input,select,textarea,[tabindex],' +
    'iframe,object,embed,summary,[contenteditable]:not([contenteditable="false"]),' +
    'audio[controls],video[controls]';

  var shellOpenName = null;
  var shellReturnTo = null;
  var shellOverflowSnapshot = null;
  var shellLastUserFocus = null;
  // The exact nodes WE inerted. Tracked in an array rather than recovered
  // with querySelectorAll('[data-qcc-inert]') so release never depends on
  // a global attribute query, and never touches inert someone else set.
  var shellInertedNodes = [];

  function shellPanel(name) { return document.getElementById(SHELL_DIALOGS[name].panelId); }
  function shellOverlay(name) { return document.getElementById(SHELL_DIALOGS[name].overlayId); }
  function shellTrigger(name) { return document.querySelector(SHELL_DIALOGS[name].triggerSelector); }

  function shellModalOpen() {
    return !!document.querySelector('.modal-ov.open');
  }

  /**
   * True only for a control a keyboard user can actually reach: attached,
   * enabled, painted, not inert, not aria-hidden, not tabindex="-1".
   *
   * getClientRects() is the browser's own answer to "is this rendered?",
   * and it already accounts for an ancestor's display:none. It matters in
   * every cart state: header.liquid puts inline display:none on
   * #cartDrawerFooter when the cart is empty, on #cartDrawerEmpty when it
   * is not, and on #cartDrawerLevelDiscount most of the time.
   *
   * `hidden` and `aria-hidden` are checked on the ANCESTOR CHAIN, not just
   * on the element: aria-hidden on a wrapper removes every descendant from
   * the accessibility tree, and layout/theme.liquid:189 already ships a
   * `<ul hidden>` of accessibility strings.
   */
  function shellIsReachable(el) {
    if (!el) return false;
    if (el.disabled) return false;
    if (el.isConnected === false) return false;
    if (el.getAttribute('tabindex') === '-1') return false;
    if (typeof el.closest === 'function' && el.closest('[inert]')) return false;
    var node = el;
    while (node && node.getAttribute) {
      if (node.hasAttribute('hidden')) return false;
      if (node.getAttribute('aria-hidden') === 'true') return false;
      node = node.parentNode;
    }
    // getClientRects() answers display:none — the inline styles header.liquid
    // puts on #cartDrawerFooter and #cartDrawerEmpty — but NOT
    // visibility:hidden: such elements are still laid out and still return
    // rects. Task 1 made visibility:hidden the primary hiding mechanism for
    // both panels, so without this test the predicate would be blind to the
    // exact state it most needs to detect.
    if (typeof getComputedStyle === 'function') {
      var cs = getComputedStyle(el);
      if (cs && (cs.visibility === 'hidden' || cs.visibility === 'collapse')) return false;
    }
    if (typeof el.getClientRects === 'function' && el.getClientRects().length === 0) return false;
    return true;
  }

  /**
   * Focus the first candidate that ACTUALLY takes focus, and return it.
   *
   * VERIFY, do not assume — the same discipline the restore chain uses.
   * `.focus()` is a request, not a guarantee: an unfocusable subtree, a UA
   * quirk or a node mid-teardown all decline it silently. Combined with
   * preventDefault(), an unverified focus call is the one pattern that loses
   * focus entirely — and inside this shell everything else on the page is
   * already inert, so the shopper has nowhere left to tab to.
   */
  function shellFocusFirst(candidates) {
    for (var i = 0; i < candidates.length; i += 1) {
      var el = candidates[i];
      if (!el || typeof el.focus !== 'function') continue;
      el.focus({ preventScroll: true });
      if (document.activeElement === el) return el;
    }
    return null;
  }

  QCC.shellFocusables = function (panel) {
    if (!panel) return [];
    return Array.prototype.slice.call(panel.querySelectorAll(SHELL_FOCUSABLE))
      .filter(shellIsReachable);
  };

  function shellApplyInert(panel, overlay) {
    var chain = [];
    var node = panel;
    while (node && node !== document.body) { chain.push(node); node = node.parentNode; }
    var status = document.getElementById('cartStatus');

    function inertSiblingsOf(container, keep) {
      if (!container || !container.childNodes) return;
      Array.prototype.slice.call(container.childNodes).forEach(function (child) {
        if (child === keep) return;
        if (chain.indexOf(child) !== -1) return;
        if (child === panel || child === overlay || child === status) return;
        if (child.hasAttribute && child.hasAttribute('inert')) return;   // already inert; leave it
        if (child.setAttribute) {
          child.setAttribute('inert', '');
          child.setAttribute('data-qcc-inert', '');
          shellInertedNodes.push(child);
        }
      });
    }

    // Walk body -> ... -> panel's parent, inerting every off-chain sibling.
    var container = document.body;
    for (var i = chain.length - 1; i >= 0; i -= 1) {
      inertSiblingsOf(container, chain[i]);
      container = chain[i];
    }
  }

  function shellReleaseInert() {
    shellInertedNodes.forEach(function (el) {
      el.removeAttribute('inert');
      el.removeAttribute('data-qcc-inert');
    });
    shellInertedNodes = [];
  }

  /**
   * FROZEN PUBLIC API — QCC.setPendingShellInvoker(el, opts)
   *
   * For any caller that opens a shell dialog after an asynchronous request.
   * Call it with the control the user activated; the next open of the named
   * dialog consumes it exactly once.
   *
   * PLACEMENT. Declare the token after everything in the handler that can
   * throw synchronously — `new FormData(form)` sits in a try/finally with no
   * catch — and before the request it belongs to. Declared earlier, a
   * synchronous throw leaves the token stranded for the next unrelated open
   * to consume. The control's DISABLED state is irrelevant: the token records
   * which element to return focus to, and that element need not be focusable
   * at declaration time. Cancel it with clearPendingShellInvoker on any path
   * that opens no dialog.
   *
   * This is the supported contract for coffee-match.js to adopt in
   * this wave under decision P8. It is deliberately separate from the
   * focusin tracker below: this is an explicit statement of intent by a
   * caller, the tracker is a heuristic last resort. Do not change this
   * signature without a new owner decision — an external caller depends
   * on it.
   */
  // The token is SCOPED, not global. A bare `next open consumes it` token is
  // wrong in two ways: a caller whose request fails never opens anything, so
  // the token strands and an unrelated later open inherits it; and a caller
  // declaring for the cart drawer would have its token consumed by whichever
  // dialog happened to open first. Scoping by dialog AND owner makes both
  // impossible, and gives the owner something it can cancel.
  var shellPending = null;   // { el, dialog, owner } or null

  /**
   * @param {Element} el      the control the user activated
   * @param {Object} [opts]
   * @param {string} [opts.dialog] 'cartDrawer' | 'mobileNav' — only this
   *                               dialog may consume the token
   * @param {string} [opts.owner]  free-form id used to cancel it later
   */
  QCC.setPendingShellInvoker = function (el, opts) {
    opts = opts || {};
    if (!el) { shellPending = null; return; }
    shellPending = { el: el, dialog: opts.dialog || null, owner: opts.owner || null };
  };

  /**
   * Cancel a token you declared but will not use — a failed request, an
   * aborted flow, a partial success that deliberately opens nothing.
   * Passing an owner cancels only that owner's token, so one caller can
   * never discard another's.
   */
  QCC.clearPendingShellInvoker = function (owner) {
    if (!shellPending) return;
    if (owner && shellPending.owner !== owner) return;
    shellPending = null;
  };

  // Heuristic last resort: the last control a user actually focused,
  // recorded BEFORE any handler disables it. This is how coffee-match.js
  // — which calls showCartDrawer() with no argument, and which this wave
  // may not edit — still gets its add button back on close.
  document.addEventListener('focusin', function (e) {
    if (e.target && e.target !== document.body) shellLastUserFocus = e.target;
  });

  // Applied by script, never in Liquid. Without JavaScript the menu
  // toggle opens nothing and the cart link navigates to /cart, so a
  // static aria-haspopup="dialog" would promise a dialog that the
  // visitor can never open.
  //
  // Re-appliable, because {% section 'header' %} is re-rendered in place by
  // the theme editor: every node this stamped is replaced by a fresh one
  // carrying none of it. aria-expanded is derived from the live state rather
  // than reset to false, so a reload cannot make the attribute contradict the
  // dialog it describes.
  function shellSyncTriggers() {
    Object.keys(SHELL_DIALOGS).forEach(function (name) {
      var trigger = shellTrigger(name);
      if (!trigger) return;
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', SHELL_DIALOGS[name].panelId);
      trigger.setAttribute('aria-expanded', shellOpenName === name ? 'true' : 'false');
    });
  }
  shellSyncTriggers();

  /**
   * A section re-render can destroy the panel an open dialog is managing.
   * Left alone, the controller keeps `shellOpenName` set, so the page stays
   * scroll-locked and inert behind an overlay that no longer exists — and
   * because the Escape handler stands down when nothing is open, there is no
   * key left that recovers it.
   *
   * Reconciliation is deliberately CONDITIONAL. A reload of some other
   * section, or one that re-renders the header without disturbing an open
   * drawer, must change nothing: tearing the drawer down under a shopper who
   * is using it would be a worse bug than the one being fixed.
   */
  document.addEventListener('shopify:section:load', function () {
    if (shellOpenName) {
      var name = shellOpenName;
      var panel = shellPanel(name);
      var alive = panel && panel.isConnected !== false &&
        panel.classList && panel.classList.contains('open');
      if (!alive) {
        shellReleaseInert();
        document.body.style.overflow = shellOverflowSnapshot || '';
        shellOverflowSnapshot = null;
        shellOpenName = null;
        // Without this the body keeps .qcc-overlay-open after the panel it
        // described is gone, and the floating chat stays hidden with no
        // overlay on screen until some later click happens to re-sync.
        QCC.syncOverlayState();
        var back = shellReturnTo;
        shellReturnTo = null;
        shellRestoreFocus([back, shellTrigger(name), document.body]);
      }
    }
    shellSyncTriggers();
  });

  QCC.getOpenShellDialog = function () { return shellOpenName; };

  /* ============================================================
     FLOATING WIDGET SUPPRESSION

     The chat launcher is position:fixed at z-index 300. The cart
     drawer (351) and a legacy .modal-ov (500) both paint above it,
     so it is never on top -- but "covered" is not "gone": it stays
     in the layout, it can show through a narrow drawer on a wide
     phone, and on iOS a tap that lands just outside the drawer
     still finds it. While an overlay surface owns the screen the
     launcher should not be there at all.

     The state lives on <body> as a class rather than in CSS,
     because the three things that open an overlay -- this
     controller, QCC.openModal, and the two legacy handlers that
     strip .open directly off a .modal-ov -- have no common element
     to hang a selector off, and :has() is not dependable on the
     iOS versions this storefront serves.
     ============================================================ */
  /**
   * THE single answer to "does an overlay own the screen right now?"
   *
   * Two consumers need it: this module hides the floating chat, and the PDP
   * sticky bar hides itself. They had a copy each, which is how a third
   * overlay type ends up suppressing one and not the other.
   */
  QCC.isOverlayLayerOpen = function () {
    if (shellModalOpen()) return true;
    // Through the public accessor on purpose: that is the seam the shell
    // state has always been read through, here and by the sticky bar.
    if (typeof QCC.getOpenShellDialog === 'function' && QCC.getOpenShellDialog()) return true;
    return false;
  };

  QCC.syncOverlayState = function () {
    var body = document.body;
    if (!body || !body.classList) return;
    body.classList.toggle('qcc-overlay-open', QCC.isOverlayLayerOpen());
  };

  QCC.openShellDialog = function (name, invoker) {
    // ATOMIC CONSUMPTION, FIRST STATEMENT.
    //
    // The pending invoker is read and cleared before ANY branch below can
    // return. Clearing it only on the success path leaves it set after an
    // unknown name, a modal refusal, or a duplicate open — and the next
    // unrelated open would then inherit a stale control and send focus
    // somewhere the user never was. It is a one-shot token: whoever calls
    // openShellDialog consumes it, successfully or not.
    // Consume only a token addressed to THIS dialog. A token scoped to
    // another dialog is left alone for its own opener; an unscoped token
    // (dialog === null) is accepted by any dialog, which is what the
    // first-party callers use.
    var pending = null;
    if (shellPending && (!shellPending.dialog || shellPending.dialog === name)) {
      pending = shellPending.el;
      shellPending = null;
    }

    var config = SHELL_DIALOGS[name];
    if (!config) return false;

    // SINGLE-OVERLAY POLICY, half 1 of 2.
    // A legacy .modal-ov is z-index 500 and renders inside <main>, so
    // opening a shell dialog over it would both bury it and inert it.
    // F-091 (the modal's own focus management) is out of this wave's
    // scope, so the two layers must never coexist. Refuse.
    if (shellModalOpen()) return false;

    // Idempotent, and idempotent means SUCCESS. Re-opening the dialog that is
    // already open must not re-snapshot body overflow (losing the caller's
    // original value) or overwrite the return target with something inside the
    // open panel — but it must report true, because the requested end state
    // holds. `false` is reserved for opens that FAILED: the header handler
    // reads it to decide whether to fall through to /cart, and a second click
    // on the cart link would otherwise navigate away from the open drawer.
    if (shellOpenName === name) return true;

    // A dialog whose panel is absent must not become "open": it would lock
    // page scroll with nothing on screen, escapable only by Escape. Every
    // template renders {% section 'header' %}, so this is latent today — the
    // guard removes the class of failure rather than the instance.
    if (!shellPanel(name)) return false;

    var transferring = !!(shellOpenName && shellOpenName !== name);
    if (transferring) QCC.closeShellDialog(shellOpenName, true);

    // Only establish a return target on a FRESH open. During a
    // menu -> cart transfer the original target is kept, because
    // activeElement is now inside the panel we just closed.
    if (!transferring) {
      // Precedence is deliberate and is the whole determinism story:
      //   1. an explicit argument      — first-party callers, exact
      //   2. the one-shot pending token — declared before self-disabling
      //   3. document.activeElement     — heuristic
      //   4. the last focusin target    — heuristic
      // Only 1 and 2 are deterministic. 3 and 4 are best-effort and can
      // be wrong whenever focus moves asynchronously between the user's
      // activation and the open — exactly coffee-match.js's situation,
      // which is why P8 exists.
      var candidate = invoker || pending;
      if (!candidate) {
        var active = document.activeElement;
        candidate = (active && active !== document.body) ? active : shellLastUserFocus;
      }
      shellReturnTo = candidate || shellTrigger(name);
      shellOverflowSnapshot = document.body.style.overflow;
    }

    var panel = shellPanel(name);
    var overlay = shellOverlay(name);
    if (panel) panel.classList.add('open');
    if (overlay) {
      if (config.overlayDisplay) overlay.style.display = 'block';
      else overlay.classList.add('open');
    }
    document.body.style.overflow = 'hidden';

    var trigger = shellTrigger(name);
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    shellOpenName = name;
    shellReleaseInert();
    shellApplyInert(panel, overlay);
    if (panel && panel.hasAttribute('inert')) {
      panel.removeAttribute('inert');
      panel.removeAttribute('data-qcc-inert');
    }

    var initial = panel && panel.querySelector(config.initialFocusSelector);
    var entry = QCC.shellFocusables(panel);
    shellFocusFirst(initial ? [initial].concat(entry) : entry);
    QCC.syncOverlayState();
    return true;
  };

  /**
   * Deterministic restore order: explicit/tracked invoker, then the dialog's
   * own trigger, then body. Never a disabled, detached, unpainted or inert
   * node — handing focus to one silently drops it.
   *
   * VERIFY, do not assume. shellIsReachable is a predicate over what we can
   * observe; .focus() is the browser's own verdict. If focus did not land,
   * fall through to the next candidate rather than returning into a void —
   * that covers visibility, content-visibility, and any future mechanism the
   * predicate does not yet know about.
   */
  function shellRestoreFocus(candidates) {
    for (var i = 0; i < candidates.length; i += 1) {
      var el = candidates[i];
      if (!el || typeof el.focus !== 'function') continue;
      if (el === document.body) { el.focus({ preventScroll: true }); return; }
      if (!shellIsReachable(el)) continue;
      el.focus({ preventScroll: true });
      if (document.activeElement === el) return;
    }
    if (document.body && document.body.focus) document.body.focus({ preventScroll: true });
  }

  QCC.closeShellDialog = function (name, transferring) {
    var config = SHELL_DIALOGS[name];
    if (!config) return;
    // Guard a mismatched close: it must not release the scroll lock,
    // the inert boundary, or the return target owned by another dialog.
    if (shellOpenName !== name) return;

    var panel = shellPanel(name);
    var overlay = shellOverlay(name);
    if (panel) panel.classList.remove('open');
    if (overlay) {
      if (config.overlayDisplay) overlay.style.display = 'none';
      else overlay.classList.remove('open');
    }

    var trigger = shellTrigger(name);
    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    shellOpenName = null;
    QCC.syncOverlayState();
    if (transferring) return;      // the incoming dialog owns teardown

    shellReleaseInert();
    // `|| ''` rather than a null check: an unset style property can read
    // back as '' or undefined depending on the host, and writing
    // `undefined` into style.overflow is not the same as clearing it.
    document.body.style.overflow = shellOverflowSnapshot || '';
    shellOverflowSnapshot = null;

    var back = shellReturnTo;
    shellReturnTo = null;
    shellRestoreFocus([back, trigger, document.body]);
  };

  // CAPTURE PHASE, DELIBERATELY.
  //
  // qcc-custom.js:137 already registers a bubble-phase keydown listener
  // that unconditionally clears EVERY .modal-ov.open on Escape. Listeners
  // on the same node fire capture-before-bubble, so registering here in
  // the bubble phase would run us AFTER that handler had already removed
  // .open — shellModalOpen() would read false, and a single Escape would
  // close the modal AND the shell. Capture lets us observe the modal
  // while it is still open, stand down, and leave that one Escape to the
  // handler that owns the topmost layer.
  document.addEventListener('keydown', function (e) {
    if (!shellOpenName) return;
    if (shellModalOpen()) return;          // a .modal-ov is painted above us
    // An IME candidate window swallows its own Escape. Acting on it would
    // close the drawer and preventDefault() the keystroke, destroying
    // in-flight composition in the discount-code input.
    if (e.isComposing || e.keyCode === 229) return;

    if (e.key === 'Escape') {
      // Suppress the default so the same Escape cannot also reach a native
      // control (a focused <select> or a browser-level cancel) after closing
      // the dialog. The legacy .modal-ov handler is unaffected: it only runs
      // when no shell dialog is open, because of the guard above.
      e.preventDefault();
      QCC.closeShellDialog(shellOpenName);
      return;
    }
    if (e.key !== 'Tab') return;

    var panel = shellPanel(shellOpenName);
    var focusables = QCC.shellFocusables(panel);
    if (!focusables.length) return;

    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    var active = document.activeElement;
    // Ordered candidate lists, so a refused wrap target falls through to the
    // next control in the direction the user was travelling rather than
    // leaving focus nowhere after preventDefault().
    var forward = focusables;
    var backward = focusables.slice().reverse();

    // Outside the panel entirely: pull focus back in.
    if (!panel || !panel.contains(active)) {
      e.preventDefault();
      shellFocusFirst(forward);
      return;
    }
    // Inside the panel but NOT a tab stop — this is the programmatic
    // heading we focused on open. Without this branch Shift+Tab matched
    // neither wrap case and the browser moved focus out of the panel.
    if (focusables.indexOf(active) === -1) {
      e.preventDefault();
      shellFocusFirst(e.shiftKey ? backward : forward);
      return;
    }
    if (e.shiftKey && active === first) {
      e.preventDefault();
      shellFocusFirst(backward);
      return;
    }
    if (!e.shiftKey && active === last) {
      e.preventDefault();
      shellFocusFirst(forward);
    }
  }, true);

  /* ============================================================
     SINGLE-OVERLAY POLICY, half 2 of 2.

     The refusal above is not enough on its own: it only stops a shell
     dialog opening over a modal. The reverse path — QCC.openModal()
     while a drawer is open — has to close the shell first, or the modal
     would be painted above an overlay that still holds the focus trap,
     and (because .modal-ov renders inside <main>) would itself be inert.

     openModal is defined at qcc-custom.js:119, ABOVE this block, so it
     already exists and is wrapped here rather than edited in place. That
     keeps the legacy modal helpers otherwise untouched, which matters
     because F-091 owns their focus behaviour and is out of scope.
     ============================================================ */
  var shellLegacyOpenModal = QCC.openModal;
  QCC.openModal = function (id) {
    // VALIDATE BEFORE TEARING ANYTHING DOWN. The legacy helper is a no-op on
    // an id that resolves to nothing, so an unconditional teardown here would
    // close the drawer, release inert, restore scroll and move focus for a
    // modal that never opens — turning a typo into a visible regression.
    var target = id ? document.getElementById(id) : null;
    if (!target) return shellLegacyOpenModal.apply(this, arguments);
    if (shellOpenName) QCC.closeShellDialog(shellOpenName);
    var opened = shellLegacyOpenModal.apply(this, arguments);
    QCC.syncOverlayState();
    return opened;
  };

  var shellLegacyCloseModal = QCC.closeModal;
  QCC.closeModal = function () {
    var closed = shellLegacyCloseModal.apply(this, arguments);
    QCC.syncOverlayState();
    return closed;
  };

  /* The backdrop click and the legacy Escape handler at the top of this file
     strip .open straight off the modal without going through QCC.closeModal,
     so neither can be wrapped. Both are registered on `document` in the
     bubble phase ABOVE this point, which means these two listeners run after
     them and observe the settled state. A click that opened or closed
     nothing simply re-asserts the class it already has. */
  document.addEventListener('click', function () { QCC.syncOverlayState(); });
  document.addEventListener('keydown', function (e) {
    if (e && e.key === 'Escape') QCC.syncOverlayState();
  });
  QCC.syncOverlayState();

  /* ============================================================
     MOBILE NAV — public entry points preserved
     ============================================================ */
  QCC.openMobileNav = function (invoker) { QCC.openShellDialog('mobileNav', invoker); };
  QCC.closeMobileNav = function () { QCC.closeShellDialog('mobileNav'); };

  document.addEventListener('click', function (e) {
    if (e.target.id === 'mobileNavOverlay') {
      QCC.closeMobileNav();
    }
  });

  /* ============================================================
     CART DRAWER — public entry points preserved.
     coffee-match.js:761 calls QCC.showCartDrawer() with NO argument
     and this wave may not edit it, so the invoker is optional and
     the focusin tracker supplies it.
     ============================================================ */
  QCC.showCartDrawer = function (invoker) {
    if (QCC.openShellDialog('cartDrawer', invoker) === false) return false;
    QCC.trackPackagingExposures(document);
    return true;
  };

  // Returns false when the drawer did NOT open, so the header link can fall
  // through to its /cart navigation instead of becoming a silent dead
  // control. Without this, a keyboard user who tabs to the cart link while a
  // .modal-ov is open gets preventDefault() plus a refusal: nothing happens
  // at all, where previously the drawer opened.
  QCC.openCartDrawer = function (invoker) {
    if (QCC.showCartDrawer(invoker) === false) return false;
    QCC.refreshCartDrawer();
    return true;
  };

  QCC.closeCartDrawer = function () { QCC.closeShellDialog('cartDrawer'); };

  document.addEventListener('click', function (e) {
    if (e.target.id === 'cartDrawerOverlay') {
      QCC.closeCartDrawer();
    }
  });

  var CART_GENERIC_FALLBACK = 'We could not update your cart. Please try again.';

  /**
   * Builds a locale-aware cart/discount URL. Multi-language and
   * multi-currency storefronts serve every route under a locale prefix
   * (e.g. "/en-ca/"); Shopify exposes that prefix as Shopify.routes.root.
   * Hardcoding root-relative paths like "/cart/add.js" would silently
   * miss that prefix on such stores.
   */
  QCC.cartRoute = function(relativePath) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + String(relativePath).replace(/^\//, '');
  };

  /**
   * The only fetch path for cart-mutating requests. Enforces response.ok so
   * a rejected Shopify request (422/400/5xx) always rejects the promise
   * instead of being parsed as a successful cart/item payload.
   */
  QCC.fetchCartJson = function(url, options, fallbackMessage) {
    return fetch(url, options)
      .catch(function() {
        throw new Error(fallbackMessage || CART_GENERIC_FALLBACK);
      })
      .then(function(response) {
        return response.json()
          .catch(function() { return {}; })
          .then(function(body) {
            if (!response.ok) {
              var reason = (body && (body.description || body.message)) || fallbackMessage || CART_GENERIC_FALLBACK;
              throw new Error(reason);
            }
            return body;
          });
      });
  };

  /**
   * Builds the truthful presentation values for one cart line: final prices
   * only, savings derived from Shopify's own original/final totals, unique
   * discount titles, and a purchase mode/cadence read only from the
   * selling-plan allocation Shopify returned (never inferred from text).
   */
  QCC.getCartLineView = function(item) {
    var unitFinal = item.final_price;
    var unitOriginal = item.original_price;
    var lineFinal = item.final_line_price;
    var lineOriginal = item.original_line_price;
    var savings = Math.max(0, lineOriginal - lineFinal);

    var seen = {};
    var discountTitles = [];
    (item.line_level_discount_allocations || []).forEach(function(allocation) {
      var title = allocation.discount_application && allocation.discount_application.title;
      if (title && !seen[title]) {
        seen[title] = true;
        discountTitles.push(title);
      }
    });

    var sellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    var purchaseMode = sellingPlan ? 'Subscription' : 'One-time purchase';
    var cadence = sellingPlan && sellingPlan.name ? sellingPlan.name : '';

    return {
      unitFinal: unitFinal,
      unitOriginal: unitOriginal,
      lineFinal: lineFinal,
      lineOriginal: lineOriginal,
      savings: savings,
      discountTitles: discountTitles,
      purchaseMode: purchaseMode,
      cadence: cadence
    };
  };

  /* ============================================================
   * STABLE LINE-ITEM IDENTITY CONTRACT
   * ============================================================
   * Shopify's Ajax Cart API documents that a cart item's `key` is NOT
   * stable for the lifetime of a line: it is recomputed whenever the
   * line's own characteristics change (e.g. its properties, or the
   * discount/selling-plan allocations applied to it), even though the
   * line itself did not move and no other line was added or removed.
   * See https://shopify.dev/docs/api/ajax/reference/cart.
   *
   * `key` therefore identifies a line only within a single cart
   * snapshot, not durably across snapshots. A queued drawer mutation
   * that captured a key before an earlier queued mutation's response
   * changes that key would otherwise silently target nothing (or, if
   * that key ever got reused, the wrong line).
   *
   * To survive a key change we track a DURABLE LOGICAL IDENTITY per
   * line — the tuple of (variant id, selling plan id, canonical
   * properties) that actually defines what a line item merges as. A
   * queued mutation captures both its clicked key AND that line's
   * durable identity at activation time (the moment the control was
   * clicked). After every authoritative cart response, every mutation
   * still waiting in the queue has its target key reconciled:
   *   - identity found under a DIFFERENT key -> the task's key follows it.
   *   - identity not found at all (the line was removed) -> no remap;
   *     the task cancels SILENTLY when it runs and can't find its row.
   *   - identity found on more than one line (should never legitimately
   *     happen — that combination is exactly what Shopify merges into
   *     one line) -> refuse to guess. The task is marked ambiguous and,
   *     when its turn comes, cancels WITH an announced error rather than
   *     retrying a stale key or picking one of the candidates.
   */
  /**
   * Canonicalizes a properties object into a key-sorted JSON string so
   * two logically-identical properties objects always serialize
   * identically regardless of key insertion order. This matters because
   * the FIRST-PAINT identity comes from Liquid's `| json` filter while
   * every later identity comes from JSON.stringify on the Ajax cart
   * response — nothing guarantees those two serializers preserve the
   * same key order for the same underlying property set.
   */
  function canonicalLineProperties(properties) {
    var props = properties || {};
    var sorted = {};
    Object.keys(props).sort().forEach(function(key) {
      sorted[key] = props[key];
    });
    return JSON.stringify(sorted);
  }

  function computeIdentityFromItem(item) {
    var sellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    return String(item.variant_id || '') + '::' + (sellingPlan ? String(sellingPlan.id) : '') + '::' + canonicalLineProperties(item.properties);
  }

  /**
   * A row's `data-cart-line-properties` attribute carries a JSON string,
   * not a canonicalized one — it must be parsed and re-canonicalized the
   * same way computeIdentityFromItem canonicalizes the live item object,
   * or two identical-but-differently-ordered serializations would
   * compare as different identities. If the attribute is not valid JSON
   * (it should always be, but this value round-trips through Liquid and
   * HTML-attribute escaping), return null rather than throwing: the
   * caller treats a null identity as "not tracked" and the mutation
   * still proceeds by key, it just isn't eligible for re-key
   * reconciliation.
   */
  function computeIdentityFromRow(row) {
    var variantId = row.getAttribute('data-cart-line-variant-id') || '';
    var sellingPlanId = row.getAttribute('data-cart-line-selling-plan-id') || '';
    var rawProperties = row.getAttribute('data-cart-line-properties') || '{}';
    var canonicalProperties;
    try {
      canonicalProperties = canonicalLineProperties(JSON.parse(rawProperties));
    } catch (e) {
      return null;
    }
    return variantId + '::' + sellingPlanId + '::' + canonicalProperties;
  }

  var AMBIGUOUS_IDENTITY = {};

  function reconcileQueuedMutationKeys(cart) {
    var identityToKey = {};
    (cart.items || []).forEach(function(item) {
      if (!item.key) return;
      var identity = computeIdentityFromItem(item);
      identityToKey[identity] = Object.prototype.hasOwnProperty.call(identityToKey, identity)
        ? AMBIGUOUS_IDENTITY
        : item.key;
    });

    cartMutationQueue.forEach(function(task) {
      if (!task.identity) {
        task.ambiguous = false;
        return;
      }
      var mappedKey = identityToKey[task.identity];
      if (mappedKey === AMBIGUOUS_IDENTITY) {
        task.ambiguous = true;
      } else {
        task.ambiguous = false;
        if (mappedKey && mappedKey !== task.key) {
          task.key = mappedKey;
        }
      }
    });
  }

  /**
   * The single entry point for applying an already-returned, authoritative
   * cart to the page: updates every count surface and re-renders the drawer
   * from the same cart response used for the count, so they can never drift.
   */
  QCC.applyCartState = function(cart) {
    reconcileQueuedMutationKeys(cart);
    QCC.updateCartCounts(cart.item_count);
    QCC.renderCartDrawer(cart);
    QCC.updateShippingProgress(document, cart.total_price);
    QCC.updateGiftOfferVisibility(document, cart);
    QCC.trackPackagingExposures(document, cart.total_price);
  };

  QCC.renderCartDrawer = function(cart) {
    var itemsEl = document.getElementById('cartDrawerItems');
    var footerEl = document.getElementById('cartDrawerFooter');
    var emptyEl = document.getElementById('cartDrawerEmpty');
    var subtotalEl = document.getElementById('cartDrawerSubtotal');
    var totalEl = document.getElementById('cartDrawerTotal');
    var levelDiscountEl = document.getElementById('cartDrawerLevelDiscount');

    if (cart.item_count === 0) {
      if (itemsEl) itemsEl.innerHTML = '';
      if (footerEl) footerEl.style.display = 'none';
      if (emptyEl) emptyEl.style.display = 'flex';
      return;
    }

    if (footerEl) footerEl.style.display = '';
    if (emptyEl) emptyEl.style.display = 'none';

    var lineSubtotal = (cart.items || []).reduce(function(sum, item) {
      return sum + QCC.getCartLineView(item).lineFinal;
    }, 0);
    var cartLevelDiscountAmount = Math.max(0, lineSubtotal - cart.total_price);
    var cartLevelTitles = (cart.cart_level_discount_applications || [])
      .map(function(discount) { return discount.title; })
      .filter(Boolean);

    if (subtotalEl) subtotalEl.textContent = QCC.formatMoney(lineSubtotal);
    if (totalEl) totalEl.textContent = QCC.formatMoney(cart.total_price);
    if (levelDiscountEl) {
      if (cartLevelTitles.length > 0 && cartLevelDiscountAmount > 0) {
        var titlesHtml = cartLevelTitles.map(function(title) {
          return '<span data-cart-level-discount-title>' + QCC.escapeHtml(title) + '</span>';
        }).join('');
        levelDiscountEl.innerHTML = titlesHtml + '<span data-cart-level-discount-amount>&minus;' + QCC.formatMoney(cartLevelDiscountAmount) + '</span>';
        levelDiscountEl.style.display = '';
      } else {
        levelDiscountEl.innerHTML = '';
        levelDiscountEl.style.display = 'none';
      }
    }

    if (itemsEl) {
      var html = '';
      cart.items.forEach(function(item, i) {
        var line = i + 1;
        var view = QCC.getCartLineView(item);
        var imgSrc = item.image ? QCC.getSizedImageUrl(item.image, '120x') : '';
        var safeUrl = QCC.escapeHtml(item.url);
        var safeKey = QCC.escapeHtml(item.key);
        var sellingPlanForIdentity = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
        var safeVariantId = QCC.escapeHtml(String(item.variant_id || ''));
        var safeSellingPlanId = QCC.escapeHtml(sellingPlanForIdentity ? String(sellingPlanForIdentity.id) : '');
        var safeProperties = QCC.escapeHtml(canonicalLineProperties(item.properties));
        html += '<div class="cart-drawer-item" data-line="' + line + '" data-cart-line-key="' + safeKey + '"'
          + ' data-cart-line-variant-id="' + safeVariantId + '"'
          + ' data-cart-line-selling-plan-id="' + safeSellingPlanId + '"'
          + ' data-cart-line-properties="' + safeProperties + '">';
        html += '<div class="cart-drawer-item-img">';
        if (imgSrc) html += '<a href="' + safeUrl + '"><img src="' + QCC.escapeHtml(imgSrc) + '" alt="' + QCC.escapeHtml(item.title) + '" loading="lazy"></a>';
        html += '</div>';
        html += '<div class="cart-drawer-item-info">';
        html += '<a href="' + safeUrl + '" class="cart-drawer-item-name">' + QCC.escapeHtml(item.product_title) + '</a>';
        if (item.variant_title) html += '<div class="cart-drawer-item-variant">' + QCC.escapeHtml(item.variant_title) + '</div>';
        html += '<div class="cart-drawer-item-price">';
        html += '<span class="cart-drawer-item-price-final" data-cart-line-final>' + QCC.formatMoney(view.lineFinal) + '</span>';
        if (view.lineOriginal > view.lineFinal) {
          html += '<span class="cart-drawer-item-price-original" data-cart-line-original>' + QCC.formatMoney(view.lineOriginal) + '</span>';
        }
        if (view.savings > 0) {
          html += '<span class="cart-drawer-item-savings" data-cart-line-savings>Save ' + QCC.formatMoney(view.savings) + '</span>';
        }
        view.discountTitles.forEach(function(title) {
          html += '<span class="cart-drawer-item-discount" data-cart-discount-title>' + QCC.escapeHtml(title) + '</span>';
        });
        html += '</div>';
        html += '<div class="cart-drawer-item-purchase-mode" data-cart-purchase-mode>' + QCC.escapeHtml(view.purchaseMode) + '</div>';
        if (view.cadence) {
          html += '<div class="cart-drawer-item-cadence" data-cart-cadence>' + QCC.escapeHtml(view.cadence) + '</div>';
        }
        var safeTitle = QCC.escapeHtml(item.title || item.product_title);
        // Stable-key data attributes + delegated click handling (below), never an
        // inline onclick with an interpolated key — avoids building a JS-string
        // argument out of a value we did not author.
        html += '<div class="cart-drawer-item-qty">';
        html += '<button type="button" data-cart-qty-decrease="' + safeKey + '" aria-label="Decrease quantity">&minus;</button>';
        html += '<input type="number" value="' + item.quantity + '" readonly aria-label="Quantity for ' + safeTitle + '">';
        html += '<button type="button" data-cart-qty-increase="' + safeKey + '" aria-label="Increase quantity">+</button>';
        html += '</div>';
        html += '<button class="cart-drawer-item-remove" data-cart-remove="' + safeKey + '" aria-label="Remove ' + safeTitle + '">Remove</button>';
        html += '</div></div>';
      });
      itemsEl.innerHTML = html;
    }
  };

  document.addEventListener('click', function(e) {
    var decreaseBtn = e.target.closest && e.target.closest('[data-cart-qty-decrease]');
    if (decreaseBtn) {
      QCC.updateDrawerQty(decreaseBtn.getAttribute('data-cart-qty-decrease'), -1);
      return;
    }
    var increaseBtn = e.target.closest && e.target.closest('[data-cart-qty-increase]');
    if (increaseBtn) {
      QCC.updateDrawerQty(increaseBtn.getAttribute('data-cart-qty-increase'), 1);
      return;
    }
    var removeBtn = e.target.closest && e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      QCC.removeDrawerItem(removeBtn.getAttribute('data-cart-remove'));
    }
  });

  QCC.refreshCartDrawer = function() {
    return QCC.fetchCartJson(QCC.cartRoute('cart.js')).then(function(cart) {
      QCC.applyCartState(cart);
    });
  };

  var CART_CHANGE_FALLBACK = 'We could not update your cart. Please try again.';

  /**
   * Queues and serializes drawer +/-/remove mutations, addressed by
   * Shopify's per-line `key`, reconciled by durable identity when that
   * key itself changes (see the stable line-item identity contract
   * above).
   *
   * A row is located by scanning every `[data-cart-line-key]` element
   * with querySelectorAll and comparing attribute VALUES with strict
   * equality — never by concatenating the (opaque, DOM-decoded) key
   * into a CSS attribute-selector string. HTML-escaping a key on render
   * only makes it safe HTML; it does not make it safe CSS-selector
   * syntax (an unescaped `"` or `\` in the key would either throw from
   * querySelector or, worse, match the wrong element).
   *
   * A rapid double click is a real, intended action — it must never be
   * silently dropped, so mutations queue rather than being ignored. Only
   * one request is ever in flight; each queued mutation resolves its
   * target row AND builds its request body only when it actually runs
   * (after every earlier queued mutation has fully settled, the drawer
   * has been re-rendered via applyCartState, and key reconciliation has
   * run), so "+","+" reads the quantity the previous one just confirmed
   * with Shopify instead of a stale value captured at click time.
   *
   * If the keyed line no longer exists by the time a queued mutation
   * runs, it cancels SILENTLY (no request, no error — there is nothing
   * left to act on). If reconciliation found its identity ambiguous
   * (see above), it cancels WITH an announced error rather than
   * guessing. If building the request throws for any other reason, the
   * approved generic error is announced and the queue keeps draining —
   * a bug in one queued task must never stall every task behind it.
   */
  var cartMutationQueue = [];
  var cartMutationBusy = false;

  function findDrawerRowByKey(key) {
    var rows = document.querySelectorAll('.cart-drawer-item[data-cart-line-key]');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute('data-cart-line-key') === key) return rows[i];
    }
    return null;
  }

  function buildMutationBody(task) {
    var row = findDrawerRowByKey(task.key);
    if (!row) return null;
    if (task.kind === 'remove') {
      return { id: task.key, quantity: 0 };
    }
    var input = row.querySelector('input');
    var current = input ? parseInt(input.value) : 1;
    var newQty = Math.max(1, current + task.delta);
    return { id: task.key, quantity: newQty };
  }

  function enqueueCartMutation(key, kind, delta) {
    var row = findDrawerRowByKey(key);
    var task = {
      key: key,
      kind: kind,
      delta: delta,
      identity: row ? computeIdentityFromRow(row) : null,
      ambiguous: false
    };
    return new Promise(function(resolve) {
      task.resolve = resolve;
      cartMutationQueue.push(task);
      drainCartMutationQueue();
    });
  }

  function drainCartMutationQueue() {
    if (cartMutationBusy) return;
    var task = cartMutationQueue.shift();
    if (!task) return;

    if (task.ambiguous) {
      // Two lines returned by Shopify share this task's durable
      // identity — refuse to guess which one is the real target.
      if (QCC.announceCartStatus) QCC.announceCartStatus(CART_CHANGE_FALLBACK);
      task.resolve();
      drainCartMutationQueue();
      return;
    }

    var body;
    try {
      body = buildMutationBody(task);
    } catch (e) {
      if (QCC.announceCartStatus) QCC.announceCartStatus(CART_CHANGE_FALLBACK);
      task.resolve();
      drainCartMutationQueue();
      return;
    }

    if (!body) {
      // The target line no longer exists — cancel this queued action
      // safely rather than sending a request against a stale target.
      task.resolve();
      drainCartMutationQueue();
      return;
    }

    cartMutationBusy = true;
    QCC.fetchCartJson(QCC.cartRoute('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }, CART_CHANGE_FALLBACK)
      .then(function(cart) {
        QCC.applyCartState(cart);
        if (QCC.announceCartStatus) {
          QCC.announceCartStatus(task.kind === 'remove' ? 'Item removed from cart.' : 'Cart updated.');
        }
      })
      .catch(function(error) {
        if (QCC.announceCartStatus) QCC.announceCartStatus(error.message || CART_CHANGE_FALLBACK);
      })
      .then(function() {
        cartMutationBusy = false;
        task.resolve();
        drainCartMutationQueue();
      });
  }

  QCC.updateDrawerQty = function(key, delta) {
    return enqueueCartMutation(key, 'delta', delta);
  };

  QCC.removeDrawerItem = function(key) {
    return enqueueCartMutation(key, 'remove', 0);
  };

  QCC.formatMoney = function(cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  QCC.updateShippingProgress = function(scope, merchandiseTotalCents) {
    if (!QCC.experimentEnabled('shippingProgress')) return;
    // The Shopify free rate applies AT $45.00, so >= is the gate and the
    // threshold is also the meter's maximum. See qcc-shipping-progress.liquid.
    var thresholdCents = 4500;
    var value = Math.min(Math.max(merchandiseTotalCents, 0), thresholdCents);
    var message = merchandiseTotalCents >= thresholdCents
      ? 'Free shipping unlocked.'
      : QCC.formatMoney(thresholdCents - merchandiseTotalCents) + ' away from free shipping.';

    scope.querySelectorAll('[data-qcc-shipping-progress]').forEach(function(progress) {
      var meter = progress.querySelector('[data-qcc-shipping-meter]');
      var status = progress.querySelector('[data-qcc-shipping-status]');
      if (meter) meter.value = value;
      if (status) status.textContent = message;
    });

    var progressElements = scope.querySelectorAll('[data-qcc-shipping-progress]');
    var visibleProgress = Array.prototype.find.call(progressElements, function(progress) {
      return packagingElementVisible(progress);
    });
    var thresholdState = merchandiseTotalCents >= thresholdCents ? 'unlocked' : 'below';
    var drawerProgress = visibleProgress && packagingSurface(visibleProgress) === 'cart_drawer';
    if (
      drawerProgress &&
      !shippingUnlockPublished &&
      lastShippingThresholdState === 'below' &&
      thresholdState === 'unlocked'
    ) {
      shippingUnlockPublished = QCC.publishPackagingEvent(
        'qcc_packaging_interaction',
        packagingPayload(
          'shipping_progress',
          packagingSurface(visibleProgress),
          'threshold_unlocked',
          'unlocked'
        )
      );
    }
    if (drawerProgress) lastShippingThresholdState = thresholdState;
  };

  QCC.escapeHtml = function(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  };

  QCC.getSizedImageUrl = function(url, size) {
    if (!url) return '';
    var match = url.match(/(.+)\.(jpg|jpeg|png|gif|webp)/i);
    if (match) return match[1] + '_' + size + '.' + match[2];
    return url;
  };

  /* ============================================================
     AJAX ADD TO CART
     ============================================================ */
  var ADD_TO_CART_FALLBACK = 'We could not add that item to your cart. Please try again.';

  function showAddToCartError(control, message) {
    if (QCC.announceCartStatus) QCC.announceCartStatus(message);
    var errorEl = control.parentElement && control.parentElement.querySelector('[data-cart-add-error]');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.style.display = 'block';
    }
  }

  /**
   * A prior failed attempt can leave visible error text next to the
   * control. Clear it at the START of every new attempt (before the
   * request even settles) so a successful retry can never coexist with
   * stale failure text left over from an earlier rejection.
   */
  function clearAddToCartError(control) {
    var errorEl = control.parentElement && control.parentElement.querySelector('[data-cart-add-error]');
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }
  }

  QCC.addToCart = function(form, button) {
    clearAddToCartError(button);
    if (QCC.clearPdpStickyError) QCC.clearPdpStickyError();
    var originalText = button.textContent;
    button.textContent = 'Adding...';
    button.disabled = true;
    // Mirror the in-flight lock onto the sticky bar immediately. The bar is
    // shown precisely when this button has left the viewport, so without
    // this the shopper sees an unchanged, still-enabled control for the
    // whole request.
    if (QCC.syncPdpStickyState) QCC.syncPdpStickyState(form);

    // Keep the theme carrier unnamed at rest so Recharge's generic
    // input[name="selling_plan"] writes cannot clear it. Expose the Shopify
    // field name only for the synchronous FormData snapshot, then remove it
    // immediately; FormData owns the copied value after construction.
    QCC.suppressInjectedRechargeWidgets(document);
    QCC.syncThemeSellingPlan(form);
    var themePlanInput = form.querySelector('[data-pdp-sub-input]');
    if (themePlanInput && themePlanInput.value) {
      themePlanInput.setAttribute('name', 'selling_plan');
    } else if (themePlanInput) {
      themePlanInput.removeAttribute('name');
    }
    var formData;
    try {
      formData = new FormData(form);
    } finally {
      if (themePlanInput) themePlanInput.removeAttribute('name');
    }
    if (themePlanInput && themePlanInput.value && typeof formData.set === 'function') {
      var variantSelect = document.getElementById('productVariantSelect');
      var route = QCC.pdpSubscriptionRoute(variantSelect && variantSelect.options
        ? variantSelect.options[variantSelect.selectedIndex] : null);
      if (route) {
        formData.set('id', route.variantId);
        formData.set('selling_plan', route.planId);
      }
    }

    QCC.setPendingShellInvoker(button, { dialog: 'cartDrawer', owner: 'qcc-add' });
    return QCC.fetchCartJson(QCC.cartRoute('cart/add.js'), { method: 'POST', body: formData }, ADD_TO_CART_FALLBACK)
      .then(function() {
        return QCC.fetchCartJson(QCC.cartRoute('cart.js'));
      })
      .then(function(cart) {
        button.textContent = 'Added!';
        button.style.background = 'var(--fo)';
        if (QCC.syncPdpStickyState) QCC.syncPdpStickyState(form);
        QCC.applyCartState(cart);
        QCC.showCartDrawer(button);
        if (QCC.announceCartStatus) QCC.announceCartStatus('Added to cart.');

        setTimeout(function() {
          button.textContent = originalText;
          button.style.background = '';
          button.disabled = false;
          if (QCC.syncPdpStickyState) QCC.syncPdpStickyState(form);
        }, 1500);
      })
      .catch(function(error) {
        button.textContent = originalText;
        button.disabled = false;
        var message = error.message || ADD_TO_CART_FALLBACK;
        showAddToCartError(button, message);
        // Restore the mirrored state first, then write the failure, so the
        // sticky bar is usable again and says why the attempt failed.
        if (QCC.syncPdpStickyState) QCC.syncPdpStickyState(form);
        if (QCC.showPdpStickyError) QCC.showPdpStickyError(message);
        QCC.clearPendingShellInvoker('qcc-add');
      });
  };

  /* ============================================================
     DISCOUNT CODE
     ============================================================ */
  var DISCOUNT_FALLBACK = "We couldn't apply that discount. Check the code and try again.";

  function normalizeDiscountTitle(title) {
    return (title || '').trim().toUpperCase();
  }

  /**
   * Proves the SPECIFIC submitted code was applied, not merely that some
   * allocation exists. A cart can already carry a prior automatic or
   * previously-applied discount when an invalid/expired/non-combinable
   * code is submitted; treating "any allocation present" as success would
   * falsely report that the new code worked.
   */
  function cartHasSpecificDiscountApplied(cart, code) {
    var target = normalizeDiscountTitle(code);
    var lineMatch = (cart.items || []).some(function(item) {
      return (item.line_level_discount_allocations || []).some(function(allocation) {
        return normalizeDiscountTitle(allocation.discount_application && allocation.discount_application.title) === target;
      });
    });
    if (lineMatch) return true;
    return (cart.cart_level_discount_applications || []).some(function(discount) {
      return normalizeDiscountTitle(discount.title) === target;
    });
  }

  /**
   * Applies a discount code through Shopify's storefront discount route
   * (there is no supported Ajax cart endpoint for discount codes) and
   * verifies application from the resulting cart's own discount
   * allocations — a redirect alone proves nothing about whether Shopify
   * actually applied the code, and the presence of some OTHER prior
   * discount proves nothing about this one.
   */
  QCC.applyDiscountCode = function(code) {
    code = (code || '').trim();
    if (!code) {
      return Promise.reject(new Error('Please enter a discount code.'));
    }
    var discountUrl = QCC.cartRoute('discount/' + encodeURIComponent(code)) + '?redirect=' + QCC.cartRoute('cart');
    return QCC.fetchCartJson(discountUrl, {}, DISCOUNT_FALLBACK)
      .then(function() {
        return QCC.fetchCartJson(QCC.cartRoute('cart.js'));
      })
      .then(function(cart) {
        if (!cartHasSpecificDiscountApplied(cart, code)) {
          throw new Error(DISCOUNT_FALLBACK);
        }
        return cart;
      });
  };

  QCC.reloadPage = function() {
    window.location.reload();
  };

  QCC.handleDiscountFormSubmit = function(form) {
    var input = form.querySelector('[data-cart-discount-input]');
    var submitBtn = form.querySelector('[data-cart-discount-submit]');
    var messageEl = form.querySelector('[data-cart-discount-message]');
    var code = input ? input.value : '';
    var reloadOnSuccess = form.hasAttribute && form.hasAttribute('data-cart-discount-reload');

    if (submitBtn) submitBtn.disabled = true;

    return QCC.applyDiscountCode(code)
      .then(function(cart) {
        if (reloadOnSuccess) {
          // The full cart page renders its rows/subtotal server-side in
          // Liquid; applyCartState only updates the drawer/counts, which
          // would leave the visible table stale after a verified discount.
          // Reload so the page re-renders from the authoritative cart.
          QCC.reloadPage();
          return;
        }
        QCC.applyCartState(cart);
        if (input) input.value = '';
        if (messageEl) messageEl.textContent = 'Discount applied.';
        if (QCC.announceCartStatus) QCC.announceCartStatus('Discount applied.');
      })
      .catch(function(error) {
        if (messageEl) messageEl.textContent = error.message;
        if (QCC.announceCartStatus) QCC.announceCartStatus(error.message);
      })
      .then(function() {
        if (submitBtn) submitBtn.disabled = false;
      });
  };

  document.addEventListener('submit', function(e) {
    var form = e.target.closest && e.target.closest('[data-cart-discount-form]');
    if (!form) return;
    e.preventDefault();
    QCC.handleDiscountFormSubmit(form);
  });

  QCC.updateCartCounts = function(itemCount) {
    var counts = document.querySelectorAll('[data-cart-count]');
    counts.forEach(function(countEl) {
      countEl.textContent = itemCount;
      if (countEl.classList.contains('cart-badge')) {
        countEl.style.display = itemCount > 0 ? 'flex' : 'none';
      }
    });
  };

  QCC.announceCartStatus = function(message) {
    var status = document.getElementById('cartStatus');
    if (status) status.textContent = message;
  };

  // Handle AJAX add-to-cart forms (product page)
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('.product-form');
    if (!form) return;

    e.preventDefault();
    var btn = form.querySelector('[data-add-to-cart], button[type="submit"]');
    if (btn) QCC.addToCart(form, btn);
  });

  QCC.handleQuickAdd = function(addBtn, variantId) {
    clearAddToCartError(addBtn);
    var originalText = addBtn.textContent;
    addBtn.textContent = 'Adding...';
    addBtn.disabled = true;

    QCC.setPendingShellInvoker(addBtn, { dialog: 'cartDrawer', owner: 'qcc-add' });
    return QCC.fetchCartJson(QCC.cartRoute('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    }, ADD_TO_CART_FALLBACK)
    .then(function() {
      return QCC.fetchCartJson(QCC.cartRoute('cart.js'));
    })
    .then(function(cart) {
      addBtn.textContent = 'Added!';
      addBtn.style.background = 'var(--fo)';
      QCC.applyCartState(cart);
      QCC.showCartDrawer(addBtn);
      if (QCC.announceCartStatus) QCC.announceCartStatus('Added to cart.');
      setTimeout(function() {
        addBtn.textContent = originalText;
        addBtn.style.background = '';
        addBtn.disabled = false;
      }, 1500);
    })
    .catch(function(error) {
      addBtn.textContent = originalText;
      addBtn.disabled = false;
      showAddToCartError(addBtn, error.message || ADD_TO_CART_FALLBACK);
      QCC.clearPendingShellInvoker('qcc-add');
    });
  };

  // Quick add buttons on product cards
  document.addEventListener('click', function(e) {
    var addBtn = e.target.closest('.pc-add[data-variant-id]');
    if (!addBtn) return;
    e.preventDefault();

    QCC.handleQuickAdd(addBtn, addBtn.getAttribute('data-variant-id'));
  });

  /* ============================================================
     PRODUCT PAGE — MULTI-BAG OFFER
     ============================================================ */
  QCC.selectMultiBag = function(button) {
    if (!QCC.experimentEnabled('multiBag') || button.disabled) return;
    var form = button.closest('.product-form');
    if (!form || typeof form.requestSubmit !== 'function') return;

    var quantity = form.querySelector('input[name="quantity"]');
    var sellingPlan = form.querySelector('[data-pdp-sub-input]');
    var oneTimeRadio = form.querySelector('input[name="pdp_purchase_mode"][value="onetime"]');
    var addToCart = form.querySelector('[data-add-to-cart]');

    QCC.publishPackagingEvent(
      'qcc_packaging_interaction',
      packagingPayload('multi_bag', 'product_page', 'offer_selected', 'not_applicable')
    );

    if (quantity) quantity.value = '2';
    if (sellingPlan) sellingPlan.value = '';
    if (oneTimeRadio) oneTimeRadio.checked = true;
    if (addToCart) addToCart.textContent = 'Add to Cart';
    form.querySelectorAll('[data-purchase]').forEach(function(option) {
      option.classList.toggle(
        'pdp-sub-opt--selected',
        option.getAttribute('data-purchase') === 'onetime'
      );
    });
    form.requestSubmit();
  };

  QCC.updateMultiBagTotal = function(form, unitPriceCents) {
    if (!QCC.experimentEnabled('multiBag')) return;
    var total = form ? form.querySelector('[data-qcc-multi-bag-total]') : null;
    if (total) total.textContent = QCC.formatMoney(unitPriceCents * 2);
  };

  QCC.updateMultiBagAvailability = function(form, available) {
    if (!QCC.experimentEnabled('multiBag') || !form) return;
    var offer = form.querySelector('[data-qcc-multi-bag-offer]');
    var button = form.querySelector('[data-qcc-multi-bag]');
    if (offer) offer.hidden = !available;
    if (button) button.disabled = !available;
    if (available) trackMultiBagExposure(form);
  };

  document.addEventListener('click', function(e) {
    var button = e.target.closest('[data-qcc-multi-bag]');
    if (!button) return;
    QCC.selectMultiBag(button);
  });

  /* ============================================================
     CART — GIFT SAMPLER OFFER
     ============================================================ */
  QCC.updateGiftOfferVisibility = function(scope, cart) {
    if (!QCC.experimentEnabled('giftSampler')) return;
    var items = cart.items || [];
    scope.querySelectorAll('[data-qcc-gift-offer]').forEach(function(offer) {
      var handle = offer.getAttribute('data-product-handle');
      var alreadyInCart = items.some(function(item) { return item.handle === handle; });
      offer.hidden = cart.item_count === 0 || alreadyInCart;
    });
  };

  QCC.addGiftSampler = function(button) {
    if (!QCC.experimentEnabled('giftSampler')) return Promise.resolve(false);
    var offer = button.closest('[data-qcc-gift-offer]');
    var error = offer ? offer.querySelector('[data-qcc-gift-error]') : null;
    var variantId = parseInt(button.getAttribute('data-variant-id'), 10);
    var originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'Adding gift…';
    if (error) error.hidden = true;

    return QCC.fetchCartJson(QCC.cartRoute('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }, ADD_TO_CART_FALLBACK)
    .then(function() {
      QCC.publishPackagingEvent(
        'qcc_packaging_interaction',
        packagingPayload(
          'gift_sampler',
          packagingSurface(offer),
          'add_succeeded',
          'not_applicable'
        )
      );
      document.querySelectorAll('[data-qcc-gift-offer]').forEach(function(giftOffer) {
        giftOffer.hidden = true;
      });
      if (button.closest('.cart-page')) {
        window.location.reload();
      } else {
        return QCC.refreshCartDrawer();
      }
    })
    .catch(function() {
      button.disabled = false;
      button.textContent = originalText;
      if (error) {
        error.textContent = 'The sampler could not be added. Refresh and try again.';
        error.hidden = false;
      }
    });
  };

  document.addEventListener('submit', function(e) {
    var form = e.target.closest('[data-qcc-gift-form]');
    if (!form) return;
    var button = form.querySelector('[data-qcc-gift-add]');
    if (!button) return;
    e.preventDefault();
    QCC.addGiftSampler(button);
  });

  // Subscribe on an individual coffee PDP adds the matching Coffee
  // Subscription variant instead. That variant's own price is the
  // subscription price, so Recharge stores and renews at it; Shopify
  // automatic discounts only apply to the first checkout and never reach
  // Recharge renewals. PDP variant id -> Coffee Subscription variant id.
  // Prices and plan ids come from #qccSubscriptionRoute (product-template),
  // so only this id map is maintained here. Anything missing falls back to
  // the PDP's own variant and plan.
  QCC.PDP_SUBSCRIPTION_VARIANTS = {
    '44973291208984': '44082663817496', '44973291241752': '44082664079640', '44973291274520': '44082664309016', '44973291307288': '44082664538392',
    '44973291340056': '44082664767768', '44973291372824': '44082664997144', '44973291405592': '44082665259288', '44973291438360': '44082665488664',
    '44973291471128': '44082665718040', '44973291536664': '44082665947416', '44973291602200': '44082666176792', '44973291667736': '44082666406168',
    '32289043644481': '44082663784728', '32289043677249': '44082664014104', '32289043710017': '44082664276248', '32289043742785': '44082664505624',
    '32289043775553': '44082664735000', '32289043808321': '44082664964376', '32289043841089': '44082665226520', '32289043873857': '44082665455896',
    '32289043906625': '44082665685272', '32289043939393': '44082665914648', '32289043972161': '44082666144024', '32289044004929': '44082666373400',
    '32167305674817': '44082663948568', '32167305707585': '44082664210712', '32167305740353': '44082664440088', '32167305773121': '44082664669464',
    '32167305805889': '44082664898840', '32167305838657': '44082665160984', '32167305871425': '44082665390360', '32167305904193': '44082665619736',
    '32167305936961': '44082665849112', '32167305969729': '44082666078488', '32167306002497': '44082666307864', '32167306035265': '44082666537240',
    '32355602464833': '47294259331352', '32355602497601': '47294259364120', '32355602530369': '47294259429656', '32355602563137': '47294259396888',
    '32355602595905': '47294259462424', '32355602628673': '47294259495192', '32355602661441': '47294259560728', '32355602694209': '47294259527960',
    '32355602726977': '47294259593496', '32355602759745': '47294259626264', '32355602792513': '47294259691800', '32355602825281': '47294259659032',
    '44973309886744': '47294269817112', '44973309919512': '47294269849880', '44973309952280': '47294269882648', '44973309985048': '47294269915416',
    '44973310017816': '47294269948184', '44973310050584': '47294269980952', '44973310083352': '47294270013720', '44973310116120': '47294270046488',
    '44973310148888': '47294270079256', '44973310181656': '47294270112024', '44973310214424': '47294270144792', '44973310247192': '47294270177560'
  };
  QCC.pdpSubscriptionRoute = function (option) {
    var plan = document.querySelector('[data-pdp-sub-input]');
    var routeEl = document.getElementById('qccSubscriptionRoute');
    if (!option || !plan || !plan.value || !routeEl) return null;
    var target = QCC.PDP_SUBSCRIPTION_VARIANTS[String(option.value)];
    if (!target) return null;
    var data;
    try { data = JSON.parse(routeEl.textContent); } catch (e) { return null; }
    var variant = data && data.variants && data.variants[target];
    var planId = data && data.plans && data.plans[plan.value];
    if (!variant || !variant.available || !planId) return null;
    return { variantId: target, planId: String(planId), price: variant.price };
  };
  QCC.pdpPurchasePrice = function (option) {
    if (!option) return null;
    var route = QCC.pdpSubscriptionRoute(option);
    return route ? route.price : option.getAttribute('data-price');
  };
  QCC.syncPdpPurchasePrice = function () {
    var select = document.getElementById('productVariantSelect');
    var option = select && select.options ? select.options[select.selectedIndex] : null;
    var display = document.getElementById('productPriceDisplay');
    var money = QCC.pdpPurchasePrice(option);
    if (!display || !money) return;
    var compare = option.getAttribute('data-compare-price');
    display.innerHTML = money + (compare && compare !== money ? ' <span class="compare-price">' + compare + '</span>' : '');
  };

  /* ============================================================
     PRODUCT PAGE — SUBSCRIPTION RADIO PICKER
     ============================================================ */
  (function () {
    var picker = document.querySelector('[data-pdp-sub-picker]');
    if (!picker) return;
    var hidden = document.querySelector('[data-pdp-sub-input]');
    var freq = picker.querySelector('[data-pdp-sub-freq]');
    var atcBtn = document.querySelector('.product-atc');
    var onetimeRadio = picker.querySelector('input[type="radio"][name="pdp_purchase_mode"][value="onetime"]');
    var onetimeLabel = onetimeRadio ? onetimeRadio.closest('.pdp-sub-opt') : null;
    var onetimeNote = onetimeLabel ? onetimeLabel.querySelector('[data-pdp-onetime-note]') : null;

    function requiresSellingPlan() {
      return picker.getAttribute('data-requires-selling-plan') === 'true';
    }

    // Persisted on the picker itself so every interaction handler — click,
    // frequency change, or a future variant-change re-sync — reads the SAME
    // authoritative current-variant availability, rather than each writer
    // carrying its own independent assumption. Defaults to available
    // (true) until updateProductVariant/reconcilePdpAddToCartState has run
    // at least once, matching the server-rendered initial state.
    function isVariantAvailable() {
      return picker.getAttribute('data-available') !== 'false';
    }

    // The single, final decision for the Add-to-Cart button's disabled
    // state and label. Called at the tail of every purchase-mode write
    // (click, frequency change, variant-change re-sync) so no writer can
    // independently set a label that disagrees with Sold Out or with what
    // the form will actually submit.
    function syncAtcButtonState() {
      QCC.syncPdpPurchasePrice();
      if (!atcBtn) return;
      if (!isVariantAvailable()) {
        // Sold Out is the highest-priority state and survives every
        // subsequent purchase-mode/frequency interaction, not just the
        // moment the variant became unavailable.
        atcBtn.disabled = true;
        atcBtn.textContent = 'Sold Out';
        if (QCC.syncPdpStickyState) QCC.syncPdpStickyState();
        return;
      }
      var onetimeChecked = !!(onetimeRadio && onetimeRadio.checked);
      var hasRealPlan = !!(hidden && hidden.value);
      var willSubmitOneTime = onetimeChecked && !hasRealPlan;
      atcBtn.disabled = false;
      atcBtn.textContent = willSubmitOneTime ? 'Add to Cart' : 'Add subscription to cart';
      if (QCC.syncPdpStickyState) QCC.syncPdpStickyState();
    }

    function setPurchaseMode(mode) {
      // Authoritative guard: Shopify's own variant.requires_selling_plan is
      // the only source of truth for whether one-time purchase is a valid
      // path — never allow 'onetime' to become the active mode while the
      // currently selected variant requires a selling plan (the disabled
      // radio attribute already prevents most paths here, but this guard
      // covers any other route into setPurchaseMode too).
      if (mode === 'onetime' && requiresSellingPlan()) {
        mode = 'subscription';
      }
      picker.querySelectorAll('.pdp-sub-opt').forEach(function (o) {
        var on = o.getAttribute('data-purchase') === mode;
        o.classList.toggle('pdp-sub-opt--selected', on);
        var radio = o.querySelector('input[type="radio"][name="pdp_purchase_mode"]');
        if (radio) radio.checked = on;
      });
      if (hidden) {
        hidden.value = mode === 'subscription' ? (freq ? freq.value : hidden.getAttribute('value')) : '';
      }
      // The CTA's label/disabled state is decided by syncAtcButtonState
      // alone (Sold Out priority, then checked-mode + payload) — never
      // written independently here, so a click or frequency change can
      // never resurrect an "Add..." label while the variant is unavailable.
      syncAtcButtonState();
    }

    // Called whenever the selected variant changes (option select or direct
    // variant select). Reflects Shopify's authoritative
    // variant.requires_selling_plan for the NEW variant — never a guess, and
    // never keyed off product handle. If the customer had one-time selected
    // and the new variant no longer allows it, falls back to subscription
    // (the only valid mode) rather than leaving an invalid state on screen.
    function updatePdpSubPickerAvailability(nowRequiresSellingPlan) {
      picker.setAttribute('data-requires-selling-plan', nowRequiresSellingPlan ? 'true' : 'false');
      if (onetimeRadio) { onetimeRadio.disabled = !!nowRequiresSellingPlan; }
      if (onetimeLabel) { onetimeLabel.classList.toggle('pdp-sub-opt--unavailable', !!nowRequiresSellingPlan); }
      if (onetimeNote) {
        onetimeNote.textContent = nowRequiresSellingPlan
          ? 'This option is only available as a subscription.'
          : 'No commitment · ship once';
      }
      if (nowRequiresSellingPlan) {
        setPurchaseMode('subscription');
      }
    }

    /**
     * The single, final authority for the Add-to-Cart button's disabled
     * state and label after a variant change. Two earlier writers —
     * updateProductVariant's generic availability check and
     * updatePdpSubPickerAvailability's picker sync — could each set the
     * button's label independently and disagree (e.g. the button kept
     * saying "Add to Cart" while subscription was actually checked with a
     * real plan queued, or briefly relabeled to "Add subscription to cart"
     * while the variant was actually sold out). This function runs last and
     * decides the final state from two priorities:
     *   1. Unavailable (Sold Out) always wins — disabled, regardless of
     *      purchase mode or selling_plan state.
     *   2. Otherwise, the label is derived from the ACTUALLY checked
     *      purchase mode together with the hidden selling_plan input's real
     *      value (what the form will really submit), not from a separately
     *      tracked assumption — so label/checked/payload/disabled can never
     *      drift apart.
     */
    function reconcilePdpAddToCartState(state) {
      state = state || {};
      // Persist availability on the picker FIRST — updatePdpSubPickerAvailability
      // may call setPurchaseMode internally (when the variant now requires a
      // plan), which itself calls syncAtcButtonState; that call must already
      // see this variant's real availability, not a stale one.
      picker.setAttribute('data-available', state.available ? 'true' : 'false');
      updatePdpSubPickerAvailability(!!state.requiresSellingPlan);
      syncAtcButtonState();
    }

    picker.addEventListener('click', function (e) {
      var label = e.target.closest('.pdp-sub-opt');
      if (!label) return;
      // Don't toggle when clicking inside the frequency dropdown
      if (e.target.closest('[data-pdp-sub-freq]')) return;
      setPurchaseMode(label.getAttribute('data-purchase'));
    });

    if (freq) {
      freq.addEventListener('change', function () {
        if (hidden) hidden.value = freq.value;
        setPurchaseMode('subscription');
      });
    }

    /**
     * The legacy Recharge Auto inject remains globally published. The
     * theme-local F-043 guard above removes its independently injected
     * purchase-mode controls from this candidate and disables those controls
     * so they cannot serialize a competing selling_plan value. This picker
     * still owns exactly one hidden input, identified by data-pdp-sub-input,
     * and initializes it from the provider-derived cadence below.
     */
    setPurchaseMode('subscription');

    QCC.updatePdpSubPickerAvailability = updatePdpSubPickerAvailability;
    QCC.reconcilePdpAddToCartState = reconcilePdpAddToCartState;
  })();

  /* ============================================================
     PRODUCT PAGE — VARIANT SELECTOR
     ============================================================ */
  var variantSelect = document.getElementById('productVariantSelect');
  // Always hide the master variant select — it's a hidden data carrier, not a user-facing dropdown
  if (variantSelect) { variantSelect.style.display = 'none'; }
  var variantsJson = document.getElementById('productVariantsJson');
  var productVariants = variantsJson ? JSON.parse(variantsJson.textContent) : [];

  function updateProductVariant(variantId) {
    if (!variantSelect) return;
    // Update the hidden select
    variantSelect.value = variantId;

    var selectedOption = variantSelect.options[variantSelect.selectedIndex];
    if (!selectedOption) return;

    var price = selectedOption.getAttribute('data-price');
    var priceCents = parseInt(selectedOption.getAttribute('data-price-cents'), 10);
    var comparePrice = selectedOption.getAttribute('data-compare-price');
    var available = selectedOption.getAttribute('data-available') === 'true';

    var priceDisplay = document.getElementById('productPriceDisplay');
    if (priceDisplay && price) {
      var html = price;
      if (comparePrice && comparePrice !== price) {
        html += ' <span class="compare-price">' + comparePrice + '</span>';
      }
      priceDisplay.innerHTML = html;
    }

    if (!isNaN(priceCents)) {
      QCC.updateMultiBagTotal(variantSelect.closest('.product-form'), priceCents);
    }
    QCC.updateMultiBagAvailability(variantSelect.closest('.product-form'), available);

    var requiresSellingPlan = selectedOption.getAttribute('data-requires-selling-plan') === 'true';

    // Single reconciliation entry point for the Add-to-Cart button: decides
    // disabled/label state from Sold Out priority, then the actually
    // checked purchase mode + hidden selling_plan state, so this generic
    // availability check and the subscription picker's own sync can never
    // leave the button disagreeing with itself.
    if (QCC.reconcilePdpAddToCartState) {
      QCC.reconcilePdpAddToCartState({ available: available, requiresSellingPlan: requiresSellingPlan });
    } else {
      // No subscription picker on this product — plain availability toggle.
      var atcBtn = document.querySelector('.product-atc');
      if (atcBtn) {
        atcBtn.disabled = !available;
        atcBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
      }
    }

    // Runs last, after every writer above has settled the canonical CTA.
    if (QCC.syncPdpStickyState) QCC.syncPdpStickyState();
  }

  // Direct variant select change
  if (variantSelect) {
    variantSelect.addEventListener('change', function() {
      updateProductVariant(this.value);
    });
  }

  // Option-based selects → find matching variant
  document.querySelectorAll('[data-option-index]').forEach(function(sel) {
    sel.addEventListener('change', function() {
      var optionSelects = document.querySelectorAll('[data-option-index]');
      var selectedOptions = [];
      optionSelects.forEach(function(s) { selectedOptions.push(s.value); });

      for (var i = 0; i < productVariants.length; i++) {
        var v = productVariants[i];
        var match = true;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (v.options[j] !== selectedOptions[j]) { match = false; break; }
        }
        if (match) {
          updateProductVariant(v.id);
          break;
        }
      }
    });
  });

  /* ============================================================
     PRODUCT PAGE — MOBILE STICKY PURCHASE BAR

     A MIRROR, never a second purchase path. The canonical Shopify product
     form stays the sole owner of variant, quantity, availability and
     subscription state; this bar only reads the canonical CTA and the
     current variant price, and acts by asking that same form to submit
     itself. It deliberately builds no cart payload of its own — a second
     serializer is exactly how the visible control and the submitted payload
     drift apart.
     ============================================================ */
  (function () {
    var STICKY_VISIBLE_CLASS = 'qcc-pdp-sticky--visible';

    // Defaults to "in view" so the bar cannot flash over a page whose
    // canonical CTA has not been measured yet.
    var stickyCtaInView = true;
    var stickyObserver = null;
    var stickyMeasure = null;
    var stickyResize = null;

    function stickyBar() { return document.querySelector('[data-qcc-pdp-sticky]'); }

    function canonicalForm() { return document.querySelector('[data-product-form]'); }

    function canonicalCta(form) {
      var scope = form || canonicalForm();
      return scope ? scope.querySelector('[data-add-to-cart]') : null;
    }

    /**
     * The money string for the variant the form will actually submit. Read
     * from the hidden master variant select, which the theme already keeps
     * authoritative on every variant change; the rendered price display is
     * only a fallback because it may also carry a compare-at price.
     */
    function currentVariantPrice() {
      var select = document.getElementById('productVariantSelect');
      var option = select && select.options ? select.options[select.selectedIndex] : null;
      var money = QCC.pdpPurchasePrice(option);
      if (money) return money;

      var display = document.getElementById('productPriceDisplay');
      if (!display) return null;
      var text = (display.textContent || '').replace(/\s+/g, ' ').trim();
      return text ? text.split(' ')[0] : null;
    }

    /**
     * One-way mirror of the canonical CTA. Called after every existing
     * variant and purchase-mode reconciliation so the bar can never show a
     * label, price or enabled state the canonical control disagrees with.
     */
    QCC.syncPdpStickyState = function (form) {
      var bar = stickyBar();
      if (!bar) return;
      var cta = canonicalCta(form);
      if (!cta) return;

      var label = bar.querySelector('[data-qcc-pdp-sticky-label]');
      var price = bar.querySelector('[data-qcc-pdp-sticky-price]');
      var button = bar.querySelector('[data-qcc-pdp-sticky-submit]');

      var ctaLabel = (cta.textContent || '').replace(/\s+/g, ' ').trim();
      var unavailable = !!cta.disabled;

      if (label) label.textContent = ctaLabel;
      if (button) button.disabled = unavailable;
      // The status line carries add failures only. Sold Out is already
      // carried by the button's own label and disabled state, which is the
      // reliable exposure: the status line sits inside a bar that is
      // visibility:hidden until the canonical CTA scrolls away, so a write
      // made while it is hidden would never be announced anyway.

      var money = currentVariantPrice();
      if (price && money) price.textContent = money;
    };

    /**
     * The visible failure message. When the bar is showing, the canonical CTA
     * and its own [data-cart-add-error] element are off-screen by
     * construction, so a sighted shopper would otherwise see nothing at all.
     * The element is aria-hidden: header.liquid's #cartStatus region already
     * announces this exact message, and a second live region would announce
     * it twice.
     */
    QCC.showPdpStickyError = function (message) {
      var bar = stickyBar();
      if (!bar) return;
      var status = bar.querySelector('[data-qcc-pdp-sticky-status]');
      if (!status) return;
      status.textContent = message || '';
      status.hidden = !message;
      // The status row is a full-width flex row: showing or clearing it
      // changes the bar's height, and the chat launcher is positioned off it.
      QCC.syncPdpStickyHeight();
    };

    QCC.clearPdpStickyError = function () { QCC.showPdpStickyError(''); };

    /**
     * Publishes the bar's ACTUAL laid-out height as --qcc-sticky-bar-height,
     * which qcc-custom.css uses to lift the floating chat launcher clear of
     * it. A constant cannot do this job: .qcc-pdp-sticky-status is
     * flex:0 0 100% and appears as a full-width row above the button
     * whenever an add fails, so the bar is materially taller in exactly the
     * state where covering it costs the shopper the failure message.
     *
     * 0px when the bar is absent or not showing, so the launcher sits at its
     * normal offset on the homepage, a collection and the cart.
     */
    QCC.syncPdpStickyHeight = function () {
      var root = document.documentElement;
      if (!root || !root.style || typeof root.style.setProperty !== 'function') return;
      var bar = stickyBar();
      var showing = !!(bar && bar.classList && bar.classList.contains(STICKY_VISIBLE_CLASS));
      var height = 0;
      if (showing) {
        if (typeof bar.getBoundingClientRect === 'function') {
          height = Math.ceil(bar.getBoundingClientRect().height || 0);
        }
        if (!height) height = bar.offsetHeight || 0;
      }
      root.style.setProperty('--qcc-sticky-bar-height', height + 'px');
    };

    QCC.updatePdpStickyVisibility = function () {
      var bar = stickyBar();
      if (!bar || !bar.classList) return;
      bar.classList.toggle(STICKY_VISIBLE_CLASS, !stickyCtaInView && !QCC.isOverlayLayerOpen());
      QCC.syncPdpStickyHeight();
    };

    function ctaWithinViewport(cta) {
      if (!cta || typeof cta.getBoundingClientRect !== 'function') return true;
      var rect = cta.getBoundingClientRect();
      var viewportHeight = window.innerHeight || 0;
      return rect.bottom > 0 && rect.top < viewportHeight;
    }

    function teardownStickyObservation() {
      if (stickyObserver) {
        stickyObserver.disconnect();
        stickyObserver = null;
      }
      if (stickyMeasure) {
        window.removeEventListener('scroll', stickyMeasure);
        window.removeEventListener('resize', stickyMeasure);
        stickyMeasure = null;
      }
      if (stickyResize) {
        window.removeEventListener('resize', stickyResize);
        window.removeEventListener('orientationchange', stickyResize);
        stickyResize = null;
      }
    }

    /**
     * Idempotent: tears down any previous observation before re-registering,
     * so a section re-render cannot leave two observers arguing over the
     * bar's visibility.
     */
    QCC.initPdpStickyBar = function () {
      var bar = stickyBar();
      var cta = canonicalCta();
      teardownStickyObservation();
      if (!bar || !cta) return;

      QCC.syncPdpStickyState();

      // The bar's height changes with the viewport (the title wraps, the
      // status row rewraps), and the chat launcher is positioned off it. The
      // no-IntersectionObserver branch below already re-measures on resize
      // via stickyMeasure; this gives the observer branch the same.
      stickyResize = function () { QCC.syncPdpStickyHeight(); };
      window.addEventListener('resize', stickyResize);
      window.addEventListener('orientationchange', stickyResize);

      if (typeof IntersectionObserver === 'function') {
        stickyObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { stickyCtaInView = !!entry.isIntersecting; });
          QCC.updatePdpStickyVisibility();
        }, { threshold: 0 });
        stickyObserver.observe(cta);
        return;
      }

      stickyMeasure = function () {
        stickyCtaInView = ctaWithinViewport(cta);
        QCC.updatePdpStickyVisibility();
      };
      window.addEventListener('scroll', stickyMeasure);
      window.addEventListener('resize', stickyMeasure);
      stickyMeasure();
    };

    document.addEventListener('click', function (e) {
      var trigger = e.target && typeof e.target.closest === 'function'
        ? e.target.closest('[data-qcc-pdp-sticky-submit]')
        : null;

      if (!trigger) {
        // Any other click may have opened or closed the cart drawer or a
        // modal; the shell's own handlers ran first, so the state read here
        // is already settled.
        QCC.updatePdpStickyVisibility();
        return;
      }

      e.preventDefault();
      if (trigger.disabled) return;

      var form = canonicalForm();
      if (!form) return;

      // The canonical CTA is the authority on whether a submission may
      // start: QCC.addToCart disables it for the whole request, and
      // form.requestSubmit() does not consult a disabled submit button. A
      // second tap during an in-flight add would otherwise post the same
      // variant to the cart twice and leave the shopper at checkout with
      // quantity 2.
      var canonical = canonicalCta(form);
      if (canonical && canonical.disabled) return;

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
        return;
      }
      // Last resort on a browser without requestSubmit: activate the
      // canonical control itself, which still routes through the form's own
      // submit handling rather than around it.
      var cta = canonicalCta(form);
      if (cta && typeof cta.click === 'function') cta.click();
    });

    // Escape closes the drawer and the nav panel; recompute after the
    // shell's own keydown handlers have run.
    document.addEventListener('keydown', function () { QCC.updatePdpStickyVisibility(); });

    /**
     * A successful add opens the cart drawer programmatically, with no click
     * or keydown to drive a recompute. Wrap the shell's own public open/close
     * — the same pattern this file already uses for QCC.openModal — so the
     * bar hides the moment the drawer takes the screen. Both wrappers return
     * the wrapped result untouched: openShellDialog's boolean is read by the
     * header handler to decide whether to fall through to /cart.
     */
    var stickyLegacyOpenShellDialog = QCC.openShellDialog;
    QCC.openShellDialog = function () {
      var result = stickyLegacyOpenShellDialog.apply(this, arguments);
      QCC.updatePdpStickyVisibility();
      return result;
    };

    var stickyLegacyCloseShellDialog = QCC.closeShellDialog;
    QCC.closeShellDialog = function () {
      var result = stickyLegacyCloseShellDialog.apply(this, arguments);
      QCC.updatePdpStickyVisibility();
      return result;
    };
  })();

  /* ============================================================
     PRODUCT PAGE — QUANTITY SELECTOR
     ============================================================ */
  document.addEventListener('click', function(e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;

    var btn = minus || plus;
    var input = btn.parentElement.querySelector('input');
    if (!input) return;

    var current = parseInt(input.value) || 1;
    if (plus) {
      input.value = current + 1;
    } else if (minus && current > 1) {
      input.value = current - 1;
    }
  });

  /* ============================================================
     PRODUCT PAGE — IMAGE THUMBNAILS
     ============================================================ */
  document.addEventListener('click', function(e) {
    var thumb = e.target.closest('.product-thumb');
    if (!thumb) return;

    var mainImage = document.querySelector('.product-main-image img');
    var newSrc = thumb.getAttribute('data-image-url');
    if (mainImage && newSrc) {
      mainImage.src = newSrc;
      document.querySelectorAll('.product-thumb').forEach(function(t) {
        t.classList.remove('active');
      });
      thumb.classList.add('active');
    }
  });

  /* ============================================================
     CART PAGE — QUANTITY UPDATES
     ============================================================ */
  document.addEventListener('click', function(e) {
    var qtyBtn = e.target.closest('[data-qty-change]');
    if (!qtyBtn) return;

    var line = parseInt(qtyBtn.getAttribute('data-line'));
    var direction = qtyBtn.getAttribute('data-direction');
    var input = qtyBtn.parentElement.querySelector('input');
    if (!input) return;

    var current = parseInt(input.value) || 1;
    var newQty = direction === 'plus' ? current + 1 : Math.max(0, current - 1);
    input.value = newQty;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: newQty })
    })
    .then(function() { window.location.reload(); });
  });

  // Cart item remove
  document.addEventListener('click', function(e) {
    var removeBtn = e.target.closest('a.cart-item-remove');
    if (!removeBtn) return;
    e.preventDefault();

    var href = removeBtn.getAttribute('href');
    fetch(href).then(function() { window.location.reload(); });
  });


  /* ==========================================================================
   * Collection sort (F-094 / D10 / B3).
   *
   * Delegated from `document`, NOT bound per card. Collision C3 in design
   * §4.2: one delegated handler already serves quick-add for three sections,
   * and re-parenting cards below would break any direct per-card binding.
   * Delegation from the document survives the reorder.
   *
   * Sorting REORDERS; it never hides a card, so the collection cannot sort
   * itself into an empty grid. B5 -- the in-collection empty result -- belongs
   * with the filter and is held behind P-07 alongside it.
   *
   * Client-side over the products the template already rendered: the
   * collection holds twelve products against `paginate ... by 24`, so the
   * whole collection is in the document (design §5.2). Native Shopify sorting
   * would need Admin configuration this lane has no authority to make.
   * ======================================================================= */
  document.addEventListener('change', function (e) {
    var controls = e.target.closest('[data-collection-controls]');
    if (!controls) return;
    var grid = document.querySelector('.collection-grid');
    if (!grid) return;

    var select = controls.querySelector('[data-collection-sort]');
    var key = select ? select.value : 'featured';

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.collection-card'));
    cards.sort(function (a, b) {
      // Featured is the DEFAULT option, so it has to be a real ordering and
      // not a no-op. Returning early here left the grid in whatever order the
      // previous sort produced: a shopper who sorted by price and then chose
      // Featured again got the price order back under the Featured label. The
      // template stamps forloop.index on each card, so the merchant's own
      // arrangement is recoverable after any number of client-side sorts.
      if (key === 'featured') {
        return Number(a.getAttribute('data-featured-index'))
             - Number(b.getAttribute('data-featured-index'));
      }
      if (key === 'title-asc') {
        return (a.getAttribute('data-title') || '')
          .localeCompare(b.getAttribute('data-title') || '');
      }
      var dir = key === 'price-asc' ? 1 : -1;
      return dir * (Number(a.getAttribute('data-price')) - Number(b.getAttribute('data-price')));
    });
    cards.forEach(function (card) { grid.appendChild(card); });
  });


  QCC.trackConversionExposures();
  if (conversionMediaQuery) {
    if (typeof conversionMediaQuery.addEventListener === 'function') {
      conversionMediaQuery.addEventListener('change', QCC.trackConversionExposures);
    } else if (typeof conversionMediaQuery.addListener === 'function') {
      conversionMediaQuery.addListener(QCC.trackConversionExposures);
    }
  }
  QCC.trackPackagingExposures(document);
  QCC.initPdpStickyBar();

})();
